// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:28:38.906Z
// Property: The Kendall (ID: 4810300029140992)
// Collections: 23 amenities, 4 floorplans (live), 18 photos, 85 POIs, 3 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "4810300029140992",
  "property_external_id": "5056164",
  "property_zillow_url": "https://www.zillow.com/apartments/indian-trail-nc/the-kendall/5XhwHZ/",
  "property_apartments_url": "https://www.apartments.com/the-kendall-indian-trail-nc/21fy90c",
  "property_google_business_url": "https://www.google.com/maps/place/The+Kendall+Apartments/data=!4m2!3m1!1s0x0:0xc70acd29c76a3dda?sa=X&ved=2ahUKEwjsg6-y1bySAxV6BDQIHeSsKpMQ_BJ6BAg9EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "9835707285",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-kendall",
  "property_name": "The Kendall",
  "property_website_url": "https://www.lifeatthekendall.com/",
  "property_domain": "https://www.lifeatthekendall.com/",
  "property_address": "1101 Flagstone Ln",
  "property_full_address": "1101 Flagstone Ln, Indian Trail, NC 28079",
  "property_address_1": "1101 Flagstone Ln",
  "property_address_2": null,
  "property_address_city": "Indian Trail",
  "property_address_state": "NC",
  "property_address_zip_full": "28079-8408",
  "property_address_zip": "28079",
  "property_address_country": "US",
  "property_address_county": "Union County",
  "property_neighborhood_address": "Union County",
  "property_address_latitude": "35.0725611",
  "property_address_longitude": "-80.6375202",
  "property_email": "kendall@alapts.com",
  "property_phone": "(704) 234-0444",
  "property_call_tracking_phone": "980-480-9464",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern comfort, Union County convenience.</strong> The Kendall pairs open one-, two-, and three-bedroom layouts with polished finishes and everyday extras in a connected Indian Trail setting. Explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_long_description": "<p><strong>Modern comfort, Union County convenience.</strong> At The Kendall, you’re close to the best of Indian Trail while still connected to Charlotte-area destinations via US-74, I-485, and nearby downtown Matthews. Choose from <a href=\"/floor-plans\">one-, two-, and three-bedroom apartment layouts</a> with open kitchens, quartz countertops, stainless steel appliances, wood-style flooring, nine-foot ceilings, oversized closets, and private patios or balconies.</p><p>Beyond your front door, <a href=\"/amenities\">everyday extras</a> make home feel easy: a swimming pool with cabana, covered outdoor kitchen, fitness center, clubhouse with WiFi, EV charging stations, package lockers, and a bark park. When you’re ready to get out, Sun Valley theater, shopping, and dining are minutes away, with Crooked Creek Park nearby for trails, disc golf, a dog park, athletic fields, and fresh air. It’s a polished apartment community in Indian Trail with room to relax, recharge, and stay connected.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019d02ed-fdec-72b8-956d-fd712197dd91.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
    "public_id": "019d02ed-fdec-72b8-956d-fd712197dd91",
    "storage_key": "property/4810300029140992/019d02ed-fdec-72b8-956d-fd712197dd91.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "252",
  "property_year_built": "2003",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.06349206349206",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee $85\nAdministrative Fee $250\nNon-Refundable Pet Fee $350 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $300\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8943833.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://thekendall.loftliving.com/login",
  "property_apply_now_url": "https://8943833.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e73e4-1858-74c6-8bff-8dea3f3f11e6.webp",
  "property_primary_logo_media": {
    "alt_text": "The Kendall logo",
    "public_id": "019e73e4-1858-74c6-8bff-8dea3f3f11e6",
    "storage_key": "property/4810300029140992/019e73e4-1858-74c6-8bff-8dea3f3f11e6.webp",
    "width": 3072,
    "height": 3072
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019d02ee-c20f-709b-8518-a41e0d8189f4.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ee-c20f-709b-8518-a41e0d8189f4",
    "storage_key": "property/4810300029140992/019d02ee-c20f-709b-8518-a41e0d8189f4.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e73e4-0f22-7275-ac01-e2203b6d97f0.webp",
  "property_icon_media": {
    "alt_text": "Gold K logo with a square outline on a white background.",
    "public_id": "019e73e4-0f22-7275-ac01-e2203b6d97f0",
    "storage_key": "property/4810300029140992/019e73e4-0f22-7275-ac01-e2203b6d97f0.webp",
    "width": 2490,
    "height": 2490
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e73e4-0f22-7275-ac01-e2203b6d97f0.webp",
  "property_fav_icon_media": {
    "alt_text": "Gold K logo with a square outline on a white background.",
    "public_id": "019e73e4-0f22-7275-ac01-e2203b6d97f0",
    "storage_key": "property/4810300029140992/019e73e4-0f22-7275-ac01-e2203b6d97f0.webp",
    "width": 2490,
    "height": 2490
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e73e4-185e-731a-8c24-9d2568cb605b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Kendall logo",
    "public_id": "019e73e4-185e-731a-8c24-9d2568cb605b",
    "storage_key": "property/4810300029140992/019e73e4-185e-731a-8c24-9d2568cb605b.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e73e4-18a8-705f-8840-08790fa7b455.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Kendall logo",
    "public_id": "019e73e4-18a8-705f-8840-08790fa7b455",
    "storage_key": "property/4810300029140992/019e73e4-18a8-705f-8840-08790fa7b455.webp",
    "width": 3072,
    "height": 3072
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#9b9647",
  "property_secondary_color": "#595a5c",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#27474a",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "724 - 1179",
  "property_sqft_min": "724",
  "property_sqft_max": "1179",
  "property_price_range": "1342 - 1818",
  "property_price_min": "1342",
  "property_price_max": "1818",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/TheKendallApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/thekendallapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJaSpcidUkVIgR2j1qxynNCsc",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/flagstone-at-indian-trail-apartments-by-highmark-residential-indian-trail",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Everyday ease meets standout amenities.</strong> At The Kendall, start with the 24-hour fitness studio or outdoor fitness park, unwind by the swimming pool with cabana, and take dinner to the covered summer kitchen and grilling area. Smart-home features, EV charging, package lockers, a bark park with agility equipment, and frisbee golf add convenience and fun just beyond your door.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at The Kendall.</strong> Choose from one-, two-, and three-bedroom apartments in Indian Trail with open living areas, separated bedrooms in select layouts, and everyday-easy finishes like quartz countertops, stainless steel appliances, breakfast bars, nine-foot ceilings, oversized closets, and private patio or balcony space in select homes.</p>",
  "property_home_gallery_blurb": "<p><strong>See The Kendall from every angle.</strong> Preview bright interiors, quartz-topped kitchens, stainless steel appliances, and open living spaces that extend to a private patio or balcony. Then picture the community moments: cabana seating by the pool, a clubhouse lounge, fitness center, grilling area, EV charging, and a bark park—all waiting in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Indian Trail convenience, mapped around you.</strong> At The Kendall, daily plans come together near Sun Valley Entertainment District, with Harris Teeter-anchored shopping, Superfood Cafe, casual dining, and Stone Theatres Sun Valley 14 close by. For time outside, Chestnut Square Park and Crossing Paths Park add green space, trails, courts, and local events. Plus, quick access to Old Monroe Road and US-74 keeps Matthews, Monroe, and Charlotte-area destinations within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents give The Kendall high marks for service that shows up.</strong><br>Reviews call out friendly onsite support, fast follow-up, and team members like Mary, Jay, and Jonas by name. From move-in questions to maintenance needs handled “immediately,” the praise is clear: response time matters here.</p><p>Residents also note the convenient Indian Trail location, with shopping, medical services, recreation, the pool, and dog park all adding to everyday ease. Read more to hear it in their own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day around Indian Trail.</strong> From The Kendall, neighborhood convenience starts with the Sun Valley Entertainment District—where Harris Teeter-anchored shopping, Superfood Cafe, casual dining, and Stone Theatres Sun Valley 14 make errands, takeout, and movie nights easy to fold into your routine. When you want fresh air, nearby Chestnut Square Park and Crossing Paths Park add open space, walking paths, courts, and community events to the local mix. And with Old Monroe Road and US-74 nearby, it’s simple to branch out toward downtown Matthews, Monroe, or Charlotte-area destinations. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits your everyday flow.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, easy from the first day.</strong> At The Kendall, your routine has more built in: start with a workout in the 24-hour fitness studio or outdoor fitness park, cool off at the swimming pool with cabana, then move dinner outside to the covered summer kitchen and grilling area. Package lockers with text and email alerts, EV charging, online resident services, and smart-home touches help keep daily logistics simple, while a bark park with agility features and frisbee golf add more ways to enjoy the grounds. Inside select one-, two-, and three-bedroom apartments in Indian Trail, quartz countertops, stainless steel appliances, white shaker-style cabinetry, breakfast bars, nine-foot ceilings, keyless entry, and private patio or balcony storage bring polish where you use it most. Explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready to call The Kendall home?</strong> Choose a one-, two-, or three-bedroom layout with modern finishes, open kitchens, and private outdoor space—then start your application online with confidence. Union County convenience and polished comfort come together here, with room to relax, recharge, and stay connected.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong> The Kendall leasing team is here to help you connect with modern apartment living in Indian Trail, from open one-, two-, and three-bedroom layouts to convenient access via US-74 and I-485. Reach out today and let us point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Kendall?</strong> Start here for quick answers about our Indian Trail apartment community, leasing details, everyday features, and what to expect when living here. If you don’t see what you need, our leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that fits your day.</strong> The Kendall’s one-, two-, and three-bedroom apartments in Indian Trail give you room to choose a layout that feels intuitive—from streamlined one-bedrooms to larger two- and three-bedroom plans with separated bedrooms and open living areas.</p><p>Inside, the details do the heavy lifting: open-concept kitchens with quartz countertops, stainless steel appliances, breakfast bars, nine-foot ceilings, oversized closets, and private patio or balcony space in select homes. Explore current pricing and availability, compare your options side by side, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which floor plan feels right in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the everyday angles.</strong> Browse The Kendall’s photo gallery for a closer look at bright apartment interiors, polished kitchens with quartz counters and stainless steel appliances, and living spaces that open toward private patio or balcony moments. Each image helps you imagine how the finishes, flooring, and natural light come together in your apartment in Indian Trail.</p><p>Outside, the scene shifts from poolside cabana seating to the clubhouse lounge, fitness center, outdoor grilling area, EV charging spaces, and bark park. Explore the photos, compare the details with our <a href=\"/amenities\">amenities</a>, then take the next step with <a href=\"/virtual-tours\">virtual tours</a> or an in-person visit.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Kendall on the map.</strong> See available one-, two-, and three-bedroom apartments, then get a feel for the Indian Trail setting—close to shopping, dining, outdoor recreation, and Charlotte-area connections via US-74, I-485, and downtown Matthews.</p>",
  "property_pets_blurb": "<p><strong>Bring the wagging tails, window-watchers, and afternoon nap experts.</strong> At The Kendall, pet-friendly apartment living in Indian Trail feels simple, with cats and dogs welcome, no weight limit, and an on-site <a href=\"/amenities\">Bark Park</a> for quick fresh-air breaks close to home.</p><p>Inside, select homes add everyday pet-life perks like private patios or balconies, wood-style flooring, and roomy closets for leashes, treats, and supplies. When it’s time to switch up the route, nearby Crooked Creek Park offers a dedicated dog park and walking paths. Review the policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Kendall fits your pet’s routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share modern comfort and everyday ease.</strong> Love the open layouts, polished finishes, and connected Indian Trail location at The Kendall? Refer a friend and invite them to discover the same room to relax, recharge, and stay connected.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Kendall.</strong><br>Keep home running smoothly with quick online tools to pay rent, submit maintenance requests, and manage your account—so you can get back to enjoying modern comfort and everyday ease in Indian Trail.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend The Kendall.</strong><br>Reviews highlight the everyday things that make apartment living feel simple: friendly onsite service, quick follow-up, and a team that helps from move-in onward. Residents call out Mary, Jay, and Jonas by name, praise how issues are handled “immediately,” and say the “response time is amazing.”</p><p>You’ll also see appreciation for the convenient Indian Trail setting, with shopping, medical services, and recreation nearby, plus community features residents actually use, including the pool and dog park. Browse the reviews below to hear directly from people who have made The Kendall their home.</p>",
  "property_created_at": "1752256177306",
  "property_scheduletour_blurb": "<p><strong>See The Kendall for yourself.</strong> Tour open one-, two-, and three-bedroom layouts with quartz countertops, stainless steel appliances, wood-style flooring, and private outdoor space—then picture how the pool, fitness center, clubhouse, and connected Indian Trail location fit into your day. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>The Kendall leasing team will follow up soon. In the meantime, picture polished Indian Trail apartment living with open layouts, quartz countertops, stainless steel appliances, and easy everyday extras designed for comfort, connection, and room to recharge.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> The Kendall’s virtual tours let you move through key spaces at your own pace, from the Caption and Virtual Tour 2 community views to the Fitness Center and a 2BR, 2BA apartment walkthrough. Notice how the open kitchen, bright living area, bedroom separation, and everyday finishes come together in the apartment tour, then switch to the fitness space for a closer look at the equipment, mirrors, and natural light. It’s an easy way to narrow your favorite details, compare what you see with the <a href=\"/gallery\">photo gallery</a>, and picture your routine in Indian Trail. When you’re ready for the next look, <a href=\"/schedule-a-tour\">schedule a tour</a> to experience The Kendall in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The Kendall",
  "property_seo_title_home": "The Kendall | Apartments in Indian Trail, NC",
  "property_seo_description_home": "Elevate your lifestyle at The Kendall in Indian Trail, NC, where modern comfort meets exceptional amenities. Choose from spacious one, two, or three-bedroom floor plans featuring smart locks, chic crown molding, and luxurious baths. Enjoy vibrant community perks like a state-of-the-art fitness center, serene dog park, and inviting outdoor kitchen. With features such as built-in desks for your remote work needs and convenient car charging stations, The Kendall is designed for your ease and enjoyment. Ready to find your new home? Come home to The Kendall today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Indian Trail, NC",
  "property_seo_description_floorplans": "\"At The Kendall in Indian Trail, NC, your ideal living space awaits! From cozy one-bedroom retreats to spacious three-bedroom designs, our thoughtfully crafted floor plans cater to every lifestyle. Whether you seek modern elegance or extra room for your family, browse our available apartment homes and envision the perfect backdrop for your next chapter.\"",
  "property_seo_title_amenities": "Amenities | Indian Trail, NC Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at The Kendall in Indian Trail, NC, where modern living meets exceptional comfort. Choose from our thoughtfully designed one, two, and three-bedroom floor plans featuring chic details like smart locks, crown molding, and built-in desks. Enjoy a seamless living experience with amenities such as a state-of-the-art fitness center, serene dog park, and stylish outdoor kitchen. Whether you’re relaxing by the pool or working in our business center, there's something here for everyone. Dive into a community that truly feels like home—your perfect retreat awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Indian Trail, NC",
  "property_seo_description_gallery": "Elevate your lifestyle at The Kendall in Indian Trail, NC—where luxury meets comfort! From spacious one to three-bedroom floor plans, every detail is designed for modern living. Enjoy amenities like a sparkling pool, state-of-the-art fitness center, and a dog park for furry friends. Explore your community with premium features such as smart locks, crown molding, and an outdoor kitchen, all while capturing the tranquility of wooded views. Picture yourself living here and experience why The Kendall is the ideal place to call home!",
  "property_seo_title_virtualtours": "Virtual Tours | The Kendall Apartments",
  "property_seo_description_virtualtours": "Experience life at The Kendall in Indian Trail, NC, where modern elegance meets comfort. Our spacious one, two, and three-bedroom floor plans are designed to suit your lifestyle. Dive into the ambiance of our community with an immersive virtual tour, and see why your next home awaits here. Take a virtual tour of our vibrant community and find the perfect apartment for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | The Kendall Apartments",
  "property_seo_description_interactivemap": "\"Unlock the charm of The Kendall in Indian Trail, NC, where versatile one, two, and three-bedroom apartments seamlessly blend modern comfort and nature-inspired elegance. Enjoy a wealth of amenities from a sparkling pool to a relaxing dog park and a state-of-the-art fitness center. Our interactive community map is your gateway to pricing, available floor plans, and the perfect home tailored just for you. Dive into a community designed for lifestyle and leisure!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Indian Trail, NC",
  "property_seo_description_neighborhood": "Nestled in the heart of Indian Trail, NC, The Kendall offers more than just stunning one, two, and three-bedroom apartments; it connects you to a vibrant community. Uncover local favorites, scenic parks, and hidden gems just moments from your front door. Dive into the neighborhood that brings convenience and charm to your lifestyle—come and see what makes The Kendall the perfect place to call home!",
  "property_seo_title_contact": "Contact Us | The Kendall",
  "property_seo_description_contact": "\"Elevate your lifestyle at The Kendall in Indian Trail, NC. Whether you're seeking a cozy one-bedroom or a spacious three-bedroom apartment, we have the perfect floor plan for you. Our friendly leasing team is ready to assist you with any inquiries. Reach out today and start your journey to exceptional living!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Indian Trail, NC",
  "property_seo_description_faqs": "Find clarity about your future home at The Kendall in Indian Trail, NC. Our FAQs page holds essential insights into our stylish one, two, and three-bedroom apartments, featuring top-notch amenities like a fitness center, dog park, and outdoor kitchen. With options for built-in desks and smart locks, your living experience is designed to fit your lifestyle. Dive into practical details, from our innovative package system to stunning wooded views. Ready to make the best decision? Browse our FAQs today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Indian Trail, NC",
  "property_seo_description_reviews": "\"Experience life at The Kendall in Indian Trail, NC, where residents enjoy spacious one, two, and three-bedroom floor plans complemented by luxurious amenities. From a refreshing pool and dog park to a state-of-the-art fitness center and resident clubhouse, every detail is designed for comfort and convenience. With smart locks, built-in desks, and easy access to the outdoors, the perfect lifestyle awaits you. Don’t just take our word for it—see what our residents have to say about calling The Kendall home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Indian Trail, NC",
  "property_seo_description_applynow": "\"Step into a lifestyle of convenience and luxury at The Kendall in Indian Trail, NC. Choose from our spacious one, two, and three-bedroom floor plans, thoughtfully designed with modern amenities like a state-of-the-art fitness center, a refreshing pool, and a tranquil dog park. Enjoy smart locks, built-in desks, and stunning wooded views, all while embracing an active community life. Your perfect apartment awaits—apply online and secure your new home today!\"",
  "property_seo_title_residentaccess": "Resident Access | The Kendall",
  "property_seo_description_residentaccess": "\"Unlock the convenience of apartment living at The Kendall in Indian Trail, NC. Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected with your community. Your seamless lifestyle awaits!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Kendall",
  "property_seo_description_referafriend": "\"Share the charm of The Kendall in Indian Trail, NC, with your friends! When you refer a friend, you’re not just bringing them home; you’re building a vibrant community. Great friends make great neighbors—help your pals discover their new abode today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Kendall",
  "property_seo_description_scheduletour": "\"Step into comfort and style at The Kendall in Indian Trail, NC! Experience modern living in a vibrant community designed for your lifestyle. Schedule a tour today to see your future home!\"",
  "property_seo_title_privacy": "Privacy Policy | The Kendall",
  "property_seo_description_privacy": "Your peace of mind matters at The Kendall in Indian Trail, NC. Learn about our commitment to safeguarding your information and ensuring a secure living experience. Curious about how we protect your privacy? View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Kendall",
  "property_seo_description_accessibility": "\"At The Kendall in Indian Trail, NC, we champion digital inclusion for everyone. Our Accessibility Statement outlines our commitment to creating an inviting online experience for all residents. Join us in building a community that values every voice.\"",
  "property_seo_title_sitemap": "Sitemap | The Kendall",
  "property_seo_description_sitemap": "\"Navigate your way to a vibrant lifestyle at The Kendall in Indian Trail, NC! Check out our sitemap for a seamless journey through our community offerings, amenities, and stunning apartment layouts that make coming home a pleasure.\"",
  "property_seo_title_thankyou": "Thank You | The Kendall",
  "property_seo_description_thankyou": "Thank you for reaching out to The Kendall in Indian Trail, NC! Your apartment journey is just beginning. Keep an eye on your inbox—our dedicated team is excited to connect and help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651138675",
  "amenities": [
    {
      "id": "custom_b9cb5637-f816-4ce9-bd30-fb490bac0b24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_566202c7-ae2b-4be3-83b6-02f0b5ebb988",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "Full-Size Washer & Dryer Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_238f1f2f-1283-4186-bf57-a9d5da422331",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000605",
      "title": "Built-In Desk",
      "amount": "0.0000",
      "description": "Built-In Desks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d13f5e71-189c-4ea8-8ed2-f7b55b295f6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Undermount Sinks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e58cf971-96c8-49b1-9ab8-1d0c834fa28c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Garden Style Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3998f6f9-2d8b-474a-8796-aa1d6d4133c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8aff0fe-bccb-43d2-87cc-20a8e6bb15b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbc7eae4-94c9-4548-898d-2505941439fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000624",
      "title": "Crown Molding",
      "amount": "0.0000",
      "description": "Crown Molding",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_366467e0-e011-4eef-bebb-efb9b1997726",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Wood-Style Cabinets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66db2a6e-62b4-480e-94fa-fe78d19518e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c0108708-bd23-448c-ac29-722fa4afa8e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9 Ft Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_90bf7d0a-fb74-43ac-a3e6-89b5e42b6849",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000707",
      "title": "Wet Bar",
      "amount": "0.0000",
      "description": "Breakfast Bar",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cec29c68-71fc-434b-8b95-25cb714ed113",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8f663a8-ab80-4fa3-8594-b78e8b5cdbe1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_823e8476-d2ad-460c-b08d-15f69185caf9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_526966dc-69e9-414f-b0f6-8f2008639446",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3f76a48c-b3e4-407c-ab1c-aef509d5c082",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9317954-0d95-42c4-bcc5-c4b0e41a37d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grilling Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b072e4d3-81dd-40d6-8c50-56345952c2da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "On-Site Laundry w/Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae3f9b2a-dcf5-40a1-8366-2f2893d62474",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Community Summer Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8ca6b68-08a7-4ba2-bd8b-103716fcacaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "24-Hour Resident Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a939207b-26cb-4679-b20d-26ee9df2c45b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e43f1f1f-82e7-49f6-b364-09c296d9a300",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_de7b9e4f-6b98-4c49-8ae4-e7776791b6c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-8886-7258-b359-9eaba855bf40.webp",
      "image_media": {
        "alt_text": "Modern living area with a gray sectional sofa and an orange sofa facing a black stone fireplace.",
        "public_id": "019e89ff-8886-7258-b359-9eaba855bf40",
        "storage_key": "property/4810300029140992/019e89ff-8886-7258-b359-9eaba855bf40.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed common areas, perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Modern living area with a gray sectional sofa and an orange sofa facing a black stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0fa9bf9c-4088-4a57-beae-6df64f6df89f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-88ac-76ee-8422-ee3b05498d71.webp",
      "image_media": {
        "alt_text": "Dog park with tunnel, agility platform, and bench.",
        "public_id": "019e89ff-88ac-76ee-8422-ee3b05498d71",
        "storage_key": "property/4810300029140992/019e89ff-88ac-76ee-8422-ee3b05498d71.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Community dog park featuring a tunnel, agility platform, and seating for residents and their pets.",
      "link": "",
      "alt_text": "Dog park with tunnel, agility platform, and bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08898261-5d1c-4d25-8e8b-60c007187e5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-8635-7390-801d-f90b109067f2.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, white bedding, and blue accent wall with starburst decor.",
        "public_id": "019e89ff-8635-7390-801d-f90b109067f2",
        "storage_key": "property/4810300029140992/019e89ff-8635-7390-801d-f90b109067f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in style in our beautifully appointed bedrooms, featuring plush bedding and a calming blue accent wall.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, white bedding, and blue accent wall with starburst decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ddb0ef7a-c711-43c4-8f20-39021947e65b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-87bc-715a-889a-5ee56bcfbb05.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, bathtub, and a large linen closet.",
        "public_id": "019e89ff-87bc-715a-889a-5ee56bcfbb05",
        "storage_key": "property/4810300029140992/019e89ff-87bc-715a-889a-5ee56bcfbb05.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a white vanity, toilet, and bathtub with a stylish pink shower curtain. Includes a large, organized linen closet for ample storage.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, bathtub, and a large linen closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2041f18c-bab2-40e8-a7f8-110d02a92241",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-8cd7-7642-b5a5-bab1af7907d0.webp",
      "image_media": {
        "alt_text": "Living room with a green couch, coffee table, and a television mounted on the wall.",
        "public_id": "019e89ff-8cd7-7642-b5a5-bab1af7907d0",
        "storage_key": "property/4810300029140992/019e89ff-8cd7-7642-b5a5-bab1af7907d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern and stylish living room featuring a comfortable green sectional sofa, a wooden coffee table, and a wall-mounted TV, with a view to a patio.",
      "link": "",
      "alt_text": "Living room with a green couch, coffee table, and a television mounted on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1c426d0-6b95-4609-adbc-0fd27ff187ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-8491-769b-98e4-25b3439dad7a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge chairs at a multifamily property on a sunny day.",
        "public_id": "019e89ff-8491-769b-98e4-25b3439dad7a",
        "storage_key": "property/4810300029140992/019e89ff-8491-769b-98e4-25b3439dad7a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge chairs at a multifamily property on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d04f2fa-c57d-4499-9a88-8919443baf00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-8534-7575-a600-ab1c22630783.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019e89ff-8534-7575-a600-ab1c22630783",
        "storage_key": "property/4810300029140992/019e89ff-8534-7575-a600-ab1c22630783.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio machines and weight training equipment, perfect for your workout routine.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e141515f-d770-44f7-9516-9130048374fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-818a-76c9-b075-0669426f48ea.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two built-in grills and a covered picnic area next to a playground.",
        "public_id": "019e89ff-818a-76c9-b075-0669426f48ea",
        "storage_key": "property/4810300029140992/019e89ff-818a-76c9-b075-0669426f48ea.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at the community grilling station, complete with built-in barbecues and a shaded picnic pavilion, adjacent to the children's playground.",
      "link": "",
      "alt_text": "Outdoor grilling station with two built-in grills and a covered picnic area next to a playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23a2daa2-e736-41fa-931c-08f42c679798",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6b58-7163-836f-d7bcd8ae06dd.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, white bedding, green and navy accent pillows, and a cane headboard.",
        "public_id": "019e89ff-6b58-7163-836f-d7bcd8ae06dd",
        "storage_key": "property/4810300029140992/019e89ff-6b58-7163-836f-d7bcd8ae06dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Retreat to this chic bedroom featuring a comfortable king-size bed, plush accent pillows, and ample closet space for effortless organization.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, white bedding, green and navy accent pillows, and a cane headboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8eb4f9f-2b6f-4b55-ac64-bdb59fd8ac21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6bbb-7487-92bf-69ff23c0c2cd.webp",
      "image_media": {
        "alt_text": "Luxurious lounge area with fireplace and seating, opening to a swimming pool area.",
        "public_id": "019e89ff-6bbb-7487-92bf-69ff23c0c2cd",
        "storage_key": "property/4810300029140992/019e89ff-6bbb-7487-92bf-69ff23c0c2cd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our elegant lounge, featuring a cozy fireplace and stylish seating, with direct access to the refreshing outdoor swimming pool.",
      "link": "",
      "alt_text": "Luxurious lounge area with fireplace and seating, opening to a swimming pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c72ac505-07e4-400e-bd7e-f95a35995b47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6bba-7399-b450-924718cf546b.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and exercise balls.",
        "public_id": "019e89ff-6bba-7399-b450-924718cf546b",
        "storage_key": "property/4810300029140992/019e89ff-6bba-7399-b450-924718cf546b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e96bf933-c175-406d-954c-70ac5e69132e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6c8c-7752-90a0-07dad0f188ea.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations and package lockers at The Kendall apartments.",
        "public_id": "019e89ff-6c8c-7752-90a0-07dad0f188ea",
        "storage_key": "property/4810300029140992/019e89ff-6c8c-7752-90a0-07dad0f188ea.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations and secure package lockers available at The Kendall apartments, enhancing the resident experience.",
      "link": "",
      "alt_text": "Electric vehicle charging stations and package lockers at The Kendall apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0915ddb3-7b6b-4b2e-a2c2-78aa4518b307",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6b18-777c-ab6b-a62b9d5ca644.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with green sofas and a coffee table, overlooking a swimming pool and apartment buildings.",
        "public_id": "019e89ff-6b18-777c-ab6b-a62b9d5ca644",
        "storage_key": "property/4810300029140992/019e89ff-6b18-777c-ab6b-a62b9d5ca644.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, complete with comfortable seating and a sparkling swimming pool perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Outdoor seating area with green sofas and a coffee table, overlooking a swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29f5fc48-f8ed-48f9-8294-513591bd3d79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6b56-7646-b752-9ab06ca2c24f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white tub, toilet, vanity, and sink. Blue towels are visible.",
        "public_id": "019e89ff-6b56-7646-b752-9ab06ca2c24f",
        "storage_key": "property/4810300029140992/019e89ff-6b56-7646-b752-9ab06ca2c24f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in the beautifully appointed bathroom, featuring a spacious tub/shower combo, elegant vanity, and ample counter space. A perfect retreat after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a white tub, toilet, vanity, and sink. Blue towels are visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7bcc4bc-b44a-4dfa-8517-9a005b2ac18d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6aa8-71bd-a894-ed4e86c11e26.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs at apartment complex",
        "public_id": "019e89ff-6aa8-71bd-a894-ed4e86c11e26",
        "storage_key": "property/4810300029140992/019e89ff-6aa8-71bd-a894-ed4e86c11e26.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Resort-style swimming pool with lounge chairs, surrounded by apartment buildings and lush landscaping. Perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs at apartment complex",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59df05f2-8a09-4a1d-86cc-9432b7fc7494",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6b9c-7709-89c7-6ffcd98d2ac6.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with bar stools and a coffee station with a retro black refrigerator.",
        "public_id": "019e89ff-6b9c-7709-89c7-6ffcd98d2ac6",
        "storage_key": "property/4810300029140992/019e89ff-6b9c-7709-89c7-6ffcd98d2ac6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a convenient coffee station and a spacious kitchen island in this modern apartment kitchen, perfect for entertaining or a quick breakfast.",
      "link": "",
      "alt_text": "Modern kitchen island with bar stools and a coffee station with a retro black refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b50c8ae2-3745-42bf-9143-361164a415c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6ae4-776b-9bc7-aa427d7c6267.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, a double sink, and a dining area with a neon 'Let's Party' sign.",
        "public_id": "019e89ff-6ae4-776b-9bc7-aa427d7c6267",
        "storage_key": "property/4810300029140992/019e89ff-6ae4-776b-9bc7-aa427d7c6267.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This bright and modern kitchen features stainless steel appliances, a spacious double sink, and an adjacent dining area, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, a double sink, and a dining area with a neon 'Let's Party' sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_818f4a85-52e7-458a-9acc-83a5d9ec6263",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019e89ff-6b30-70b3-ac40-64e31cfd2eb3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a double sink.",
        "public_id": "019e89ff-6b30-70b3-ac40-64e31cfd2eb3",
        "storage_key": "property/4810300029140992/019e89ff-6b30-70b3-ac40-64e31cfd2eb3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this beautifully appointed apartment kitchen, featuring sleek white cabinetry, premium stainless steel appliances, and a spacious double sink.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_e59ccb3394924bb488c4e183",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "The Trail House",
      "poi_type": "Restaurants",
      "poi_address": "6751 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Low-key, unfussy venue serving American comfort cuisine, plus a full bar & outdoor seating.",
      "poi_long_description": "Low-key, unfussy venue serving American comfort cuisine, plus a full bar & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0be0-7107-86e3-33758c76d2ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0be0-7107-86e3-33758c76d2ac",
        "storage_key": "property/4810300029140992/019f14ef-0be0-7107-86e3-33758c76d2ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thetrailhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2760693121814930736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-trail-house",
      "poi_latitude": "35.049232",
      "poi_longitude": "-80.64554799999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-776-4655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCzxuvEclVIgRMKWke8TzTyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_41b982d5d409dd38042ce99e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Tap and Vine Indian Trail",
      "poi_type": "Restaurants",
      "poi_address": "6443 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Comfortable place offering gourmet tapas, burgers and more in a warm setting with patio seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-03e5-7704-b648-7146b00c87f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-03e5-7704-b648-7146b00c87f1",
        "storage_key": "property/4810300029140992/019f14ef-03e5-7704-b648-7146b00c87f1.webp",
        "width": 1280,
        "height": 839
      },
      "poi_business_url": "https://tapandvinenc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8377399982795842800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tap-and-vine-indian-trail",
      "poi_latitude": "35.0518008",
      "poi_longitude": "-80.6469772",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-776-9597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwh_mJslVIgR8OToI-aAQnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_0933cce7f8ad1032440f1c99",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Sun Valley Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6751 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Home-style American fare for breakfast, lunch & dinner served in a casual shopping-mall space.",
      "poi_long_description": "Home-style American fare for breakfast, lunch & dinner served in a casual shopping-mall space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-08c4-746e-8eba-c7ae37e53843.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-08c4-746e-8eba-c7ae37e53843",
        "storage_key": "property/4810300029140992/019f14ef-08c4-746e-8eba-c7ae37e53843.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.sunvalleycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12792224517960114901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sun-valley-cafe",
      "poi_latitude": "35.0492293",
      "poi_longitude": "-80.6454353",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-283-0808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9QHVUYlVIgR1SIOSGwch7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "ec_858d7ba75153f7d5cf05f755",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Kaizoku Japanese Cuisine & Poke Bowl",
      "poi_type": "Restaurants",
      "poi_address": "6461 Old Monroe Rd Ste C, Indian Trail, NC 28079, USA",
      "poi_short_description": "Casual restaurant offering a variety of Japanese fare including teriyaki, hibachi, and sushi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0843-7633-8a21-97d35b1f0374.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0843-7633-8a21-97d35b1f0374",
        "storage_key": "property/4810300029140992/019f14ef-0843-7633-8a21-97d35b1f0374.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kaizokupokebowl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=326351273698654024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaizoku-japanese-cuisine--poke-bowl",
      "poi_latitude": "35.051072",
      "poi_longitude": "-80.64600159999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-313-8685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQSKh0clVIgRSPfNHMFuhwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_73a540f82a15a441a210c141",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Chokh Di Noodle House",
      "poi_type": "Restaurants",
      "poi_address": "14015 E Independence Blvd Ste I, Indian Trail, NC 28079, USA",
      "poi_short_description": "Casual, cozy, hot eatery offering an abundance of Thai fare and Vietnamese dishes, as well as sushi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0856-7149-a51f-651e46a9e61a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0856-7149-a51f-651e46a9e61a",
        "storage_key": "property/4810300029140992/019f14ef-0856-7149-a51f-651e46a9e61a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chokhdinoodlehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16870444052822363225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chokh-di-noodle-house",
      "poi_latitude": "35.0795537",
      "poi_longitude": "-80.6549304",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-893-0571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4mfrOAkVIgRWQyUi3vbH-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_f60a4ce82823576c24512ccc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "The Bridge",
      "poi_type": "Restaurants",
      "poi_address": "5902 Indian Trail Fairview Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Casual eatery with homey vibes for traditional American fare like burgers, omelets and pancakes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-07ff-73a2-8f91-6ccfb2df54df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-07ff-73a2-8f91-6ccfb2df54df",
        "storage_key": "property/4810300029140992/019f14ef-07ff-73a2-8f91-6ccfb2df54df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://thebridgerestaurantnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14172397991328419849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bridge",
      "poi_latitude": "35.1034047",
      "poi_longitude": "-80.63146669999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-882-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTbQdQU07VIgRCRCXcOJ4rsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_73db76368151d7150b9c3e81",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Wise Acres Organic Farm",
      "poi_type": "Restaurants",
      "poi_address": "4701 Hartis Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0422-72dd-afac-f9065ef6f4c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0422-72dd-afac-f9065ef6f4c4",
        "storage_key": "property/4810300029140992/019f14ef-0422-72dd-afac-f9065ef6f4c4.webp",
        "width": 548,
        "height": 382
      },
      "poi_business_url": "http://www.wiseacresorganic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3537595674843378625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wise-acres-organic-farm",
      "poi_latitude": "35.0874421",
      "poi_longitude": "-80.5968943",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTJkTgw7VIgRwXP_9YUQGDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "ec_b928a512b0cb0d73839a2507",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Charanda Authentic Mexican Eatery",
      "poi_type": "Restaurants",
      "poi_address": "6437 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0592-723c-9743-e5fbb6503da8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0592-723c-9743-e5fbb6503da8",
        "storage_key": "property/4810300029140992/019f14ef-0592-723c-9743-e5fbb6503da8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15982758835398705645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charanda-authentic-mexican-eatery",
      "poi_latitude": "35.05134049999999",
      "poi_longitude": "-80.6464579",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-210-3390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxxhaYQlVIgR7QGtAnsqzt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_04e8c2537c023cff370d4a5d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Cactus Rose Cafe",
      "poi_type": "Restaurants",
      "poi_address": "633 Indian Trail Road South, Indian Trail, NC 28079, USA",
      "poi_short_description": "Casual eatery for Mexican favorites such as enchiladas, tacos, burritos and margarita pitchers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0d5d-712a-b5f3-23cc554c3e93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0d5d-712a-b5f3-23cc554c3e93",
        "storage_key": "property/4810300029140992/019f14ef-0d5d-712a-b5f3-23cc554c3e93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/Cactus-Rose-191153917612811/?ref=aymt_homepage_panel",
      "poi_directions_map_url": "https://maps.google.com/?cid=5498392478326352676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cactus-rose-cafe",
      "poi_latitude": "35.0684345",
      "poi_longitude": "-80.6773826",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-821-7673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-MmDV4jVIgRJGtSytM2Tkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_513d5ea76b2d6217028c67f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Rockhounds Coffee",
      "poi_type": "Restaurants",
      "poi_address": "4705 Indian Trail Fairview Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-03fa-75bd-8677-20311db64606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-03fa-75bd-8677-20311db64606",
        "storage_key": "property/4810300029140992/019f14ef-03fa-75bd-8677-20311db64606.webp",
        "width": 1088,
        "height": 600
      },
      "poi_business_url": "https://rockhoundscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4437980534803055330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockhounds-coffee",
      "poi_latitude": "35.0919156",
      "poi_longitude": "-80.6522564",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51ee-767f-9cef-d7bae0e00964.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51ee-767f-9cef-d7bae0e00964",
        "storage_key": "property/4810300029140992/019f14ef-51ee-767f-9cef-d7bae0e00964.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJaWWErjIlVIgR4sIIccjflj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_4ba7f25b3ebb1e807569205f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Cathy's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "606 Indian Trail Road South, Indian Trail, NC 28079, USA",
      "poi_short_description": "Casual coffee shop, serving lattes and muffins, plus pastries, smoothies and breakfast sandwiches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0d76-72ab-a8bb-2d4c53702135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0d76-72ab-a8bb-2d4c53702135",
        "storage_key": "property/4810300029140992/019f14ef-0d76-72ab-a8bb-2d4c53702135.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cathys-coffee.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5952590093841252009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cathys-coffee",
      "poi_latitude": "35.0691925",
      "poi_longitude": "-80.678499",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-821-7375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51ee-767f-9cef-d7bae0e00964.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51ee-767f-9cef-d7bae0e00964",
        "storage_key": "property/4810300029140992/019f14ef-51ee-767f-9cef-d7bae0e00964.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ38r7sQAlVIgRqb7q9CbZm1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_efb8c0c3d6f551372e99c161",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "13801 E Independence Blvd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-4e05-747c-9285-870239be4ab3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-4e05-747c-9285-870239be4ab3",
        "storage_key": "property/4810300029140992/019f14e9-4e05-747c-9285-870239be4ab3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/nc/indian-trail?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5140498296321313000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.0838041",
      "poi_longitude": "-80.6595986",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-882-2697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6gACuYkVIgR6Ii7CPe3Vkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_2471bc78d5ce229ada212523",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Wingstop",
      "poi_type": "Restaurants",
      "poi_address": "6605 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0c25-74ad-8c5e-5a29ab05796f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0c25-74ad-8c5e-5a29ab05796f",
        "storage_key": "property/4810300029140992/019f14ef-0c25-74ad-8c5e-5a29ab05796f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.wingstop.com/location/wingstop-3211-indian-trail-nc-28079/menu?y_source=1_MjAyOTE2MDUxMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11281048834810652378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wingstop",
      "poi_latitude": "35.0488171",
      "poi_longitude": "-80.6468903",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-501-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_5ygqtElVIgR2ia5TCVWjpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "ec_1b7b9f258351f516b1611398",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "First China",
      "poi_type": "Restaurants",
      "poi_address": "6640 Old Monroe Rd Ste f, Indian Trail, NC 28079, USA",
      "poi_short_description": "Dumplings, sesame chicken & other American Chinese standards offered in a popular strip-mall eatery.",
      "poi_long_description": "Dumplings, sesame chicken & other American Chinese standards offered in a popular strip-mall eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-10eb-72f2-b6f9-93ffe40f98cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-10eb-72f2-b6f9-93ffe40f98cf",
        "storage_key": "property/4810300029140992/019f14ef-10eb-72f2-b6f9-93ffe40f98cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1521051881328666049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-china",
      "poi_latitude": "35.0471611",
      "poi_longitude": "-80.64790339999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-226-8828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQUwlEYlVIgRweWIj6DcGxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_d5d06995d3ec31894d00fee5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "La Unica Mexican Restaurant Indian Trail",
      "poi_type": "Restaurants",
      "poi_address": "4305 Old Monroe Rd Ste A, Indian Trail, NC 28079, USA",
      "poi_short_description": "Casual eatery serving Mexican favorites, such as enchilada combinations, tacos, fajitas, chimichangas, and steaks .",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1081-7519-8818-169375a8a316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1081-7519-8818-169375a8a316",
        "storage_key": "property/4810300029140992/019f14ef-1081-7519-8818-169375a8a316.webp",
        "width": 1280,
        "height": 873
      },
      "poi_business_url": "https://launicarestaurants.com/launicaindiantrail?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=6247185297686191022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-unica-mexican-restaurant-indian-trail",
      "poi_latitude": "35.067763",
      "poi_longitude": "-80.6774969",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-821-7281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTqI0KklVIgRrtug4u11slY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f519c80e3f4c3f739ab48110",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "5704 W Hwy 74, Indian Trail, NC 28079, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-11ae-735f-aa2d-ac1980fd9a15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-11ae-735f-aa2d-ac1980fd9a15",
        "storage_key": "property/4810300029140992/019f14ef-11ae-735f-aa2d-ac1980fd9a15.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/nc/indian-trail/5704-w-hwy-74/f965",
      "poi_directions_map_url": "https://maps.google.com/?cid=14110978097974920336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.063294",
      "poi_longitude": "-80.63491499999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e3-75bd-87c4-7500f24f04a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e3-75bd-87c4-7500f24f04a4",
        "storage_key": "property/4810300029140992/019f14e9-86e3-75bd-87c4-7500f24f04a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD8e7Di0lVIgRkMQcI9FD1MM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_c94a424837b94e8ff9b46fa4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "4423 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Unpretentious chain supermarket offering a mix of familiar and organic products, plus a deli and bakery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-15a8-779a-a8f5-0170cd612db4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-15a8-779a-a8f5-0170cd612db4",
        "storage_key": "property/4810300029140992/019f14ef-15a8-779a-a8f5-0170cd612db4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.foodlion.com/nc/indian-trail/4423-old-monroe-rd?y_source=1_NTA0NjMwOC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17785379175909680501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.0681377",
      "poi_longitude": "-80.6762713",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-821-9179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e3-75bd-87c4-7500f24f04a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e3-75bd-87c4-7500f24f04a4",
        "storage_key": "property/4810300029140992/019f14e9-86e3-75bd-87c4-7500f24f04a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-jxawclVIgRdeW5JyFc0vY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_4ed27af17926be47a6385a8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2101 Younts Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Retail chain offering a wide range of merchandise, including clothing, electronics, and home goods, plus groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-145e-769d-a599-aba9755d52c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-145e-769d-a599-aba9755d52c2",
        "storage_key": "property/4810300029140992/019f14ef-145e-769d-a599-aba9755d52c2.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3700-indian-trail-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11660418084043753936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.0787817",
      "poi_longitude": "-80.6498598",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-882-5566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-030cf9451b5a",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi4Map94kVIgR0An4x3cg0qE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_6a9594861cef346c8effdf1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Lidl",
      "poi_type": "Shopping & Retail",
      "poi_address": "14600 E Independence Blvd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Discount grocery chain carrying produce, meat, baked goods, and seafood, plus European specialties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-12e3-736f-98d2-cc3849f6ede1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-12e3-736f-98d2-cc3849f6ede1",
        "storage_key": "property/4810300029140992/019f14ef-12e3-736f-98d2-cc3849f6ede1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lidl.com/stores/US01097",
      "poi_directions_map_url": "https://maps.google.com/?cid=13889767181376906370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "35.0755512",
      "poi_longitude": "-80.6539131",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e3-75bd-87c4-7500f24f04a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e3-75bd-87c4-7500f24f04a4",
        "storage_key": "property/4810300029140992/019f14e9-86e3-75bd-87c4-7500f24f04a4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdslQOElVIgRgmTZCqldwsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_ba31176199c6cf8cc7c059a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "5711 W Hwy 74, Indian Trail, NC 28079, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-3f98-72c9-97de-a6f84a49a12f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-3f98-72c9-97de-a6f84a49a12f",
        "storage_key": "property/4810300029140992/019f14e9-3f98-72c9-97de-a6f84a49a12f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/NC-Indian-Trail/2907?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2907-_-na-_-0-_-0&y_source=1_MTE4MzgyMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9540857968037728356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.061744",
      "poi_longitude": "-80.638379",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-225-7110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-030cf9451b5a",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnZ6Tvy0lVIgRZBBYtcXvZ4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_dad7aafb3bea9e4f82547f4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "13720 W Hwy 74, Indian Trail, NC 28079, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1608-7472-9b73-206cb8d12a0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1608-7472-9b73-206cb8d12a0d",
        "storage_key": "property/4810300029140992/019f14ef-1608-7472-9b73-206cb8d12a0d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-13720+independence+blvd-indian+trail-nc-28079/id=7401",
      "poi_directions_map_url": "https://maps.google.com/?cid=15276591298284833341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.0837503",
      "poi_longitude": "-80.66152509999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-821-1589",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSUh6uUkVIgRPUoX0dhaAdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_d8a23d1d5cb49f7cd0b38084",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "304 Unionville Indian Trail Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-16d6-73c4-9c61-fea8f99205f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-16d6-73c4-9c61-fea8f99205f9",
        "storage_key": "property/4810300029140992/019f14ef-16d6-73c4-9c61-fea8f99205f9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/nc/indian-trail/304-unionville-indian-trl-35596?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14630010502172050728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "35.0762299",
      "poi_longitude": "-80.65123460000001",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 980-315-8222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51f2-73e9-ba74-0eb619bc0969.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51f2-73e9-ba74-0eb619bc0969",
        "storage_key": "property/4810300029140992/019f14ef-51f2-73e9-ba74-0eb619bc0969.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJL7l2It8kVIgRKAUz4gk9CMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_65fa905e3f85e7e6a07d6506",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1071 Chestnut Ln, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1a00-7276-a220-2c4b5b916d44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1a00-7276-a220-2c4b5b916d44",
        "storage_key": "property/4810300029140992/019f14ef-1a00-7276-a220-2c4b5b916d44.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/indian-trail/1071-chestnut-ln/2701501?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6200883129460020610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "35.0699162",
      "poi_longitude": "-80.6987834",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-234-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51f2-73e9-ba74-0eb619bc0969.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51f2-73e9-ba74-0eb619bc0969",
        "storage_key": "property/4810300029140992/019f14ef-51f2-73e9-ba74-0eb619bc0969.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ4UqRYbYlVIgRglUtQVr2DVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_927644651c58291a9ff6f62a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "4508 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1801-70bd-934f-2f4bd32f81dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1801-70bd-934f-2f4bd32f81dd",
        "storage_key": "property/4810300029140992/019f14ef-1801-70bd-934f-2f4bd32f81dd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/nc/indian-trail/4508-old-monroe-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4613740429847311214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "35.0664371",
      "poi_longitude": "-80.6763963",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-364-0116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-030cf9451b5a",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1e27mAclVIgRbjPo7nlMB0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_c3744ec120cd59c2f567af0f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "7907 Idlewild Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1a07-7349-ab0d-dbeafaf56a28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1a07-7349-ab0d-dbeafaf56a28",
        "storage_key": "property/4810300029140992/019f14ef-1a07-7349-ab0d-dbeafaf56a28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.familydollar.com/nc/hemby-bridge/7907-idlewild-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13824003210264537144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "35.1062534",
      "poi_longitude": "-80.63465339999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-364-0016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-030cf9451b5a",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ639zK60kVIgROGitUa252L8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_0ca653e87e08a2a0e7128bfa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Sardis Elementary School",
      "poi_type": "Education",
      "poi_address": "4416 Sardis Church Rd, Monroe, NC 28110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ucps.k12.nc.us/sardis",
      "poi_directions_map_url": "https://maps.google.com/?cid=161900148571260058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sardis-elementary-school",
      "poi_latitude": "35.0708471",
      "poi_longitude": "-80.6208755",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-296-3145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD9WqACwlVIgRmkSszFMvPwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_b916ee3d0a08c75ad34e07b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Porter Ridge Middle School (PRMS)",
      "poi_type": "Education",
      "poi_address": "2827 Ridge Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ucps.k12.nc.us/Domain/35",
      "poi_directions_map_url": "https://maps.google.com/?cid=16221409464196253294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "porter-ridge-middle-school-prms",
      "poi_latitude": "35.0891807",
      "poi_longitude": "-80.5712396",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-225-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtTUNMZY7VIgRbsaThfYFHuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_785516d1d1040c73b3367770",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Porter Ridge High School",
      "poi_type": "Education",
      "poi_address": "2839 Ridge Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1dca-71fe-8095-637ed63b6eca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1dca-71fe-8095-637ed63b6eca",
        "storage_key": "property/4810300029140992/019f14ef-1dca-71fe-8095-637ed63b6eca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ucps.k12.nc.us/domain/34",
      "poi_directions_map_url": "https://maps.google.com/?cid=4337691605847252352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "porter-ridge-high-school",
      "poi_latitude": "35.0905838",
      "poi_longitude": "-80.5740371",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-292-7662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE0a_EpU7VIgRgB24j4iTMjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_40d4a70e5030973bc07ef444",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Porter Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "2843 Ridge Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ucps.k12.nc.us/Domain/33",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091275315192009236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "porter-ridge-elementary-school",
      "poi_latitude": "35.0935976",
      "poi_longitude": "-80.5759165",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-289-1965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX4-EEpU7VIgRFBIUlCIg7Jk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_d9ad1c6050792674125433ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Indian Trail Elementary School",
      "poi_type": "Education",
      "poi_address": "200 Education Dr, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1caf-715e-84f1-4133307f8915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1caf-715e-84f1-4133307f8915",
        "storage_key": "property/4810300029140992/019f14ef-1caf-715e-84f1-4133307f8915.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ucps.k12.nc.us/Domain/18",
      "poi_directions_map_url": "https://maps.google.com/?cid=17603178125080027973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-trail-elementary-school",
      "poi_latitude": "35.0743557",
      "poi_longitude": "-80.6743501",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-296-3095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh3wY4AElVIgRRWNSNz0NS_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_3d1bec20384037c34fc1d7ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Poplin Elementary School",
      "poi_type": "Education",
      "poi_address": "5627 Poplin Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ucps.k12.nc.us/poplin",
      "poi_directions_map_url": "https://maps.google.com/?cid=2696781198181773784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "poplin-elementary-school",
      "poi_latitude": "35.0860347",
      "poi_longitude": "-80.6000478",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-296-0320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ76rjVhI7VIgR2LGTKjbkbCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_4a61298729d4755315405fce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Hemby Bridge Elementary",
      "poi_type": "Education",
      "poi_address": "6701 Indian Trail Fairview Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ucps.k12.nc.us/Domain/17",
      "poi_directions_map_url": "https://maps.google.com/?cid=16014072110143916642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hemby-bridge-elementary",
      "poi_latitude": "35.107104",
      "poi_longitude": "-80.61808880000001",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-296-6352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnSwDyls7VIgRYkqe7LxpPd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5f96442b704a3ca21099d56b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Metrolina Christian Academy",
      "poi_type": "Education",
      "poi_address": "732 Indian Trail Fairview Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.metrolinachristian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3923249716448366309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metrolina-christian-academy",
      "poi_latitude": "35.0851189",
      "poi_longitude": "-80.6569793",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-882-3375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg28pHuYkVIgR5Y4OstQucjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_c834e806c0f70c4b60bca555",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "The Goddard School of Indian Trail",
      "poi_type": "Education",
      "poi_address": "1004 Harvest Red Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Chain offering preschool care for infants to pre-K (up to age 5), with creative programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1a08-7169-8457-4dcde6c10616.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1a08-7169-8457-4dcde6c10616",
        "storage_key": "property/4810300029140992/019f14ef-1a08-7169-8457-4dcde6c10616.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.goddardschool.com/Indian-TrailNC?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=2595102747005549670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-indian-trail",
      "poi_latitude": "35.044754",
      "poi_longitude": "-80.65114500000001",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-289-8103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ03B_pUMlVIgRZvzn7jKoAyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_6e4595e8be77944c353df230",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Childtime of Indian Trail",
      "poi_type": "Education",
      "poi_address": "120 Business Park Dr, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1a56-727f-8168-d24984a75fbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1a56-727f-8168-d24984a75fbd",
        "storage_key": "property/4810300029140992/019f14ef-1a56-727f-8168-d24984a75fbd.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.childtime.com/your-local-school/indian-trail-nc-2014/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2014",
      "poi_directions_map_url": "https://maps.google.com/?cid=16659641133064632924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childtime-of-indian-trail",
      "poi_latitude": "35.0782912",
      "poi_longitude": "-80.6617907",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 877-220-0584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN6zrlOMkVIgRXLrNDVjvMuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_03f068ceea7bdddfeef69d7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Sun Valley 14 Cinemas",
      "poi_type": "Entertainment",
      "poi_address": "6449 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Well-kept multiplex for new releases, featuring snack concessions, comfy seating, birthday party events and kid-friendly summer deals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1c9c-7286-b504-3a61ecd57332.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1c9c-7286-b504-3a61ecd57332",
        "storage_key": "property/4810300029140992/019f14ef-1c9c-7286-b504-3a61ecd57332.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.gtcmovies.com/sunvalley/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=17735140150055356355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sun-valley-14-cinemas",
      "poi_latitude": "35.052022",
      "poi_longitude": "-80.6461394",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-220-1064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-5216-721e-aec8-8ee80483586d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-5216-721e-aec8-8ee80483586d",
        "storage_key": "property/4810300029140992/019f14ef-5216-721e-aec8-8ee80483586d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJK67mhzglVIgRw0fRbQDgH_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_bd97824ca5d0a969ed36bc08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Masterpiece Escape Room",
      "poi_type": "Entertainment",
      "poi_address": "14015 E Independence Blvd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Interactive, horror-themed room escape with challenging puzzles, plus friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-1e37-74ad-ba3e-094fa2396e08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-1e37-74ad-ba3e-094fa2396e08",
        "storage_key": "property/4810300029140992/019f14ef-1e37-74ad-ba3e-094fa2396e08.webp",
        "width": 680,
        "height": 453
      },
      "poi_business_url": "http://www.masterpieceescapes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7963175692542449238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "masterpiece-escape-room",
      "poi_latitude": "35.0796129",
      "poi_longitude": "-80.65499129999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-628-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3i0rOAkVIgRVpYEBhrigm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_281c273ccb49950bad98c68f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Extreme Ice Center",
      "poi_type": "Entertainment",
      "poi_address": "4705 Indian Trail Fairview Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Ice facility offering skating lessons, hockey & curling plus a tavern, pro shop & an upstairs gym.",
      "poi_long_description": "Ice facility offering skating lessons, hockey & curling plus a tavern, pro shop & an upstairs gym.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-222d-759c-be7c-d22a7cb01e8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-222d-759c-be7c-d22a7cb01e8c",
        "storage_key": "property/4810300029140992/019f14ef-222d-759c-be7c-d22a7cb01e8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.xicenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12183491986831788221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "extreme-ice-center",
      "poi_latitude": "35.0919696",
      "poi_longitude": "-80.6521444",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-882-1830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Zh_BsEkVIgRvUjtPml1FKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_skating_rink"
    },
    {
      "id": "ec_bb96a4937e28ebca215cf35a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Wise Acres Organic Farm",
      "poi_type": "Entertainment",
      "poi_address": "4701 Hartis Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0422-72dd-afac-f9065ef6f4c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0422-72dd-afac-f9065ef6f4c4",
        "storage_key": "property/4810300029140992/019f14ef-0422-72dd-afac-f9065ef6f4c4.webp",
        "width": 548,
        "height": 382
      },
      "poi_business_url": "http://www.wiseacresorganic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3537595674843378625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wise-acres-organic-farm",
      "poi_latitude": "35.0874421",
      "poi_longitude": "-80.5968943",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTJkTgw7VIgRwXP_9YUQGDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "ec_bbb247d3f71b36d25b7203d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "The Trail House",
      "poi_type": "Entertainment",
      "poi_address": "6751 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Low-key, unfussy venue serving American comfort cuisine, plus a full bar & outdoor seating.",
      "poi_long_description": "Low-key, unfussy venue serving American comfort cuisine, plus a full bar & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-0be0-7107-86e3-33758c76d2ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-0be0-7107-86e3-33758c76d2ac",
        "storage_key": "property/4810300029140992/019f14ef-0be0-7107-86e3-33758c76d2ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thetrailhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2760693121814930736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-trail-house",
      "poi_latitude": "35.049232",
      "poi_longitude": "-80.64554799999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-776-4655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-0615838d8410",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-0615838d8410.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCzxuvEclVIgRMKWke8TzTyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_bc4de56eb03807b9b9654aea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Stella-Rye Pub, Cafe & Lounge",
      "poi_type": "Entertainment",
      "poi_address": "1507 Waxhaw Indian Trail Rd Building 2, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-222d-759c-be7c-cc16501e3ac9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-222d-759c-be7c-cc16501e3ac9",
        "storage_key": "property/4810300029140992/019f14ef-222d-759c-be7c-cc16501e3ac9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stella-rye.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8299920621671414187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stella-rye-pub-cafe--lounge",
      "poi_latitude": "35.064376",
      "poi_longitude": "-80.67984899999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-441-8968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51f0-76fc-baa0-1dce11f3f318.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51f0-76fc-baa0-1dce11f3f318",
        "storage_key": "property/4810300029140992/019f14ef-51f0-76fc-baa0-1dce11f3f318.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcYhQYtolVIgRq_mpntQ9L3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_064cd94d6084b67860ce8310",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "JukeBox",
      "poi_type": "Entertainment",
      "poi_address": "5801 W Hwy 74, Indian Trail, NC 28079, USA",
      "poi_short_description": "Laid-back watering hole featuring beer, wings, pool tables and darts, plus live bands.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-22ee-767d-a322-7f2762bbdaf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-22ee-767d-a322-7f2762bbdaf7",
        "storage_key": "property/4810300029140992/019f14ef-22ee-767d-a322-7f2762bbdaf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9782232688084276464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jukebox",
      "poi_latitude": "35.063535",
      "poi_longitude": "-80.63778210000001",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-684-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51f0-76fc-baa0-1dce11f3f318.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51f0-76fc-baa0-1dce11f3f318",
        "storage_key": "property/4810300029140992/019f14ef-51f0-76fc-baa0-1dce11f3f318.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAy4VLi0lVIgR8FR6I814wYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_b584880950e83173f051ac7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Bricks & Minifigs Indian Trail",
      "poi_type": "Entertainment",
      "poi_address": "6431 Old Monroe Rd C, Indian Trail, NC 28079, USA",
      "poi_short_description": "Toy shop dealing in new and used Lego sets and mini figures.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2595-7542-98fa-94ae75aedeea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2595-7542-98fa-94ae75aedeea",
        "storage_key": "property/4810300029140992/019f14ef-2595-7542-98fa-94ae75aedeea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bricksandminifigs.com/indiantrail-nc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6280920537722212532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bricks--minifigs-indian-trail",
      "poi_latitude": "35.0504458",
      "poi_longitude": "-80.6466129",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-774-1174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8630-761d-937c-030cf9451b5a",
        "storage_key": "property/4810300029140992/019f14e9-8630-761d-937c-030cf9451b5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtzXCEEclVIgRtFBjifNPKlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "toy_store"
    },
    {
      "id": "ec_3124891b9aada88407417396",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Painting with a Twist",
      "poi_type": "Entertainment",
      "poi_address": "6461 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Chain of art studios offering easy-to-follow painting classes for groups & individuals.",
      "poi_long_description": "Chain of art studios offering easy-to-follow painting classes for groups & individuals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-29e9-77f2-80b3-6005fcf248c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-29e9-77f2-80b3-6005fcf248c6",
        "storage_key": "property/4810300029140992/019f14ef-29e9-77f2-80b3-6005fcf248c6.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.paintingwithatwist.com/studio/indian-trail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17352541837561533858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "painting-with-a-twist",
      "poi_latitude": "35.0510985",
      "poi_longitude": "-80.64601309999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-635-8352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh13c6UMlVIgRopX1Ed2c0PA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_studio"
    },
    {
      "id": "ec_ae27a9148ded7c2fc06be03f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Sun Valley Social House",
      "poi_type": "Entertainment",
      "poi_address": "6455 Old Monroe Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-25ee-77ec-ad0b-fcc77dcf114a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-25ee-77ec-ad0b-fcc77dcf114a",
        "storage_key": "property/4810300029140992/019f14ef-25ee-77ec-ad0b-fcc77dcf114a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7348166509648129428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sun-valley-social-house",
      "poi_latitude": "35.0516286",
      "poi_longitude": "-80.6454814",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-218-2865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51f0-76fc-baa0-1dce11f3f318.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51f0-76fc-baa0-1dce11f3f318",
        "storage_key": "property/4810300029140992/019f14ef-51f0-76fc-baa0-1dce11f3f318.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ67KLGMlVIgRlK3_HYLu-WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "ec_1aee75348142674b373ac7db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Atrium Health Union",
      "poi_type": "Health and Wellness",
      "poi_address": "600 Hospital Dr, Monroe, NC 28112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2ab8-726e-a65f-5ba1350b9502.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2ab8-726e-a65f-5ba1350b9502",
        "storage_key": "property/4810300029140992/019f14ef-2ab8-726e-a65f-5ba1350b9502.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-union?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=14699194454889092193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-union",
      "poi_latitude": "34.9756436",
      "poi_longitude": "-80.5225735",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 980-993-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8690-763d-a426-03d132c83d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8690-763d-a426-03d132c83d66",
        "storage_key": "property/4810300029140992/019f14e9-8690-763d-a426-03d132c83d66.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW55Qz982VIgRYVQOIHoH_ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_ab52b92b8a3f2c522ab72480",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "AFC Urgent Care Indian Trail",
      "poi_type": "Health and Wellness",
      "poi_address": "14001 E Independence Blvd Ste C, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2787-75aa-aeb8-55eeb7cc67bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2787-75aa-aeb8-55eeb7cc67bf",
        "storage_key": "property/4810300029140992/019f14ef-2787-75aa-aeb8-55eeb7cc67bf.webp",
        "width": 1125,
        "height": 634
      },
      "poi_business_url": "https://www.afcurgentcare.com/indian-trail-nc/patient-services/walk-in-urgent-care-indian-trail-nc/?utm_source=gbp-website-button&utm_medium=gbp-organic&utm_campaign=gbp-organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=10438857100852914182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-indian-trail",
      "poi_latitude": "35.0801277",
      "poi_longitude": "-80.6557062",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-247-6598",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZGxdUElVIgRBuhmzTlF3pA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_0c6a1f4ed2ae7c6f55b4c9d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "6030 W Hwy 74 Ste A, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2802-703d-8f1f-28c6186ec5ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2802-703d-8f1f-28c6186ec5ba",
        "storage_key": "property/4810300029140992/019f14ef-2802-703d-8f1f-28c6186ec5ba.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-indian-trail?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=6985986818854176746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "35.06964019999999",
      "poi_longitude": "-80.6438273",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-246-2777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbzd8i4lVIgR6kddl_8182A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_0798fb99d4c4c3586236344a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2101 Younts Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-29d5-7166-b61d-3295f414668d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-29d5-7166-b61d-3295f414668d",
        "storage_key": "property/4810300029140992/019f14ef-29d5-7166-b61d-3295f414668d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/3700-indian-trail-nc/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16079805300203119761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.0782945",
      "poi_longitude": "-80.65006040000002",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-882-6853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-5216-721e-aec8-890ce53a3094",
        "storage_key": "property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4Map94kVIgRkeQM4LnxJt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a710736aed8d9cfe6d3d9a0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "13720 W Hwy 74, Indian Trail, NC 28079, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2ca1-74af-9189-b5150420d95d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2ca1-74af-9189-b5150420d95d",
        "storage_key": "property/4810300029140992/019f14ef-2ca1-74af-9189-b5150420d95d.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-13720+independence+blvd-indian+trail-nc-28079/id=7401",
      "poi_directions_map_url": "https://maps.google.com/?cid=10276289572513451852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "35.0837503",
      "poi_longitude": "-80.66152509999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-821-1589",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-5216-721e-aec8-890ce53a3094",
        "storage_key": "property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQc76uUkVIgRTA-3iuu2nI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a674dad0bd133a422737420b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 Wesley Chapel Stouts Rd, Monroe, NC 28110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2c9d-70fa-9f46-46c5b30a71ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2c9d-70fa-9f46-46c5b30a71ae",
        "storage_key": "property/4810300029140992/019f14ef-2c9d-70fa-9f46-46c5b30a71ae.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/monroe-nc-pharmacies/2901-wesley-chapel-stouts-rd-monroe-nc-28110/storeid=1742?WT.mc_id=LS_GOOGLE_RX_1742",
      "poi_directions_map_url": "https://maps.google.com/?cid=605423284131478695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.0483422",
      "poi_longitude": "-80.645438",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-283-9163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-5216-721e-aec8-890ce53a3094",
        "storage_key": "property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9autEclVIgRpzxo7UTlZgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_91928b10fabb88ef031d6b61",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Indian Trail Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "106 Indian Trail Road South, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-314c-7286-99cd-95a28926f14c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-314c-7286-99cd-95a28926f14c",
        "storage_key": "property/4810300029140992/019f14ef-314c-7286-99cd-95a28926f14c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.indiantrailpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12587623918623383787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-trail-pharmacy",
      "poi_latitude": "35.07696749999999",
      "poi_longitude": "-80.6691625",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-821-7617",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-5216-721e-aec8-890ce53a3094",
        "storage_key": "property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLzlZrP0kVIgR6-DBC0M5sK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d011410ebf741434af9f8f62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Hillcrest Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7892 Idlewild Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-35a6-75b8-87b6-13a94aed0a56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-35a6-75b8-87b6-13a94aed0a56",
        "storage_key": "property/4810300029140992/019f14ef-35a6-75b8-87b6-13a94aed0a56.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "https://www.myhillcrestpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9650678796074138381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillcrest-pharmacy",
      "poi_latitude": "35.1073284",
      "poi_longitude": "-80.63394840000001",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-821-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-5216-721e-aec8-890ce53a3094",
        "storage_key": "property/4810300029140992/019f14ef-5216-721e-aec8-890ce53a3094.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoaCRHK0kVIgRDbtkyTsZ7oU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_7bb47a4940dddb9e035b08af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "13705 E Independence Blvd, Indian Trail, NC 28079, USA",
      "poi_short_description": "Relaxed, clean gym featuring strength machines and cardio equipment, plus group fitness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-5eb0-72eb-979a-81cb7e8877ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-5eb0-72eb-979a-81cb7e8877ca",
        "storage_key": "property/4810300029140992/019f14e9-5eb0-72eb-979a-81cb7e8877ca.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/indian-trail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4085303378894664090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "35.0866249",
      "poi_longitude": "-80.6600717",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-893-0355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw9nib-8kVIgRmjG4OsfpsTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_23964478eba73e64acbb4674",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "HOTWORX - Indian Trail, NC - Sun Valley Commons",
      "poi_type": "Health and Wellness",
      "poi_address": "6467 Old Monroe Rd Suite B-C, Indian Trail, NC 28079, USA",
      "poi_short_description": "Chain fitness studio offering virtually guided isometric workouts in infrared saunas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2d7c-712b-b6c9-d398344182fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2d7c-712b-b6c9-d398344182fa",
        "storage_key": "property/4810300029140992/019f14ef-2d7c-712b-b6c9-d398344182fa.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/indiantrail-sunvalleycommons?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7194547900336293178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---indian-trail-nc---sun-valley-commons",
      "poi_latitude": "35.0503835",
      "poi_longitude": "-80.6462001",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-220-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB1XU5QQlVIgROsUTbzIr2GM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_62a23a69464ff516fc6486f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Crossing Paths Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "120 Blythe Dr, Indian Trail, NC 28079, USA",
      "poi_short_description": "Laid-back park offering walking paths and a playground, plus a stage for events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2eac-76ae-a6c5-a79e43126d64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2eac-76ae-a6c5-a79e43126d64",
        "storage_key": "property/4810300029140992/019f14ef-2eac-76ae-a6c5-a79e43126d64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.indiantrail.org/262/Crossing-Paths-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16191424257737807869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossing-paths-park",
      "poi_latitude": "35.0788994",
      "poi_longitude": "-80.6687709",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-821-8114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf52eZ_wkVIgR_dcampN-s-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1ea930eae9bb99bed56aff23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Chestnut Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "320 Chestnut Pkwy, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2f18-752b-8f10-30c6be37cc98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2f18-752b-8f10-30c6be37cc98",
        "storage_key": "property/4810300029140992/019f14ef-2f18-752b-8f10-30c6be37cc98.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.indiantrail.org/Facilities/Facility/Details/Chestnut-Square-Park-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=15870188877904942734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chestnut-square-park",
      "poi_latitude": "35.0821785",
      "poi_longitude": "-80.6676176",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-821-8114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaWGCiGYlVIgRjhbhWbM8Ptw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_af44fa40f0ea68e7ad960065",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Crooked Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Crooked Creek Park, 5900 Oakwood Ln, Indian Trail, NC 28079, USA",
      "poi_short_description": "Kid-friendly park that features baseball fields, playgrounds and a splash pad.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-704e-7108-985b-c5aca45dcbc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-704e-7108-985b-c5aca45dcbc3",
        "storage_key": "property/4810300029140992/019f14e9-704e-7108-985b-c5aca45dcbc3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://itsparksandrec.com/551/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=7228265605590083627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crooked-creek-park",
      "poi_latitude": "35.0651466",
      "poi_longitude": "-80.61695689999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-821-8114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCwkPoXY7VIgRK-hec0X1T2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_67a4613679cc16940f2b481e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Squirrel Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1631 Pleasant Plains Rd, Matthews, NC 28105, USA",
      "poi_short_description": "Recreation area with a playground, charcoal grills, picnic tables, fishing piers & restrooms.",
      "poi_long_description": "Recreation area with a playground, charcoal grills, picnic tables, fishing piers & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-7106-705e-8109-1a66a6aed7a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-7106-705e-8109-1a66a6aed7a1",
        "storage_key": "property/4810300029140992/019f14e9-7106-705e-8109-1a66a6aed7a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.matthewsnc.gov/facilityview.aspx?fid=46",
      "poi_directions_map_url": "https://maps.google.com/?cid=12272761902962772969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "squirrel-lake-park",
      "poi_latitude": "35.0997222",
      "poi_longitude": "-80.7230556",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-708-1260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaMklJ8mVIgR6QsLR-2bUao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2efeed2bf4c1d1bc77b9b185",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Fred Kirby Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3505 Faith Church Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-3465-750c-947c-4191a86220cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-3465-750c-947c-4191a86220cc",
        "storage_key": "property/4810300029140992/019f14ef-3465-750c-947c-4191a86220cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unioncountync.gov/government/departments-f-p/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=2919148952436039235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-kirby-park",
      "poi_latitude": "35.0801492",
      "poi_longitude": "-80.63472349999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-283-3885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1OdddQkVIgRQ15nhIHmgig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6b82bda0cfab61881ac0994b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Stallings Municipal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "340 Stallings Rd, Stallings, NC 28104, USA",
      "poi_short_description": "Park with a splash pad, 4 playgrounds, tennis and pickleball courts, picnic areas, and a walking loop.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-76f2-728d-ae19-cbad40e605cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-76f2-728d-ae19-cbad40e605cc",
        "storage_key": "property/4810300029140992/019f14e9-76f2-728d-ae19-cbad40e605cc.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.stallingsnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5297723141723541116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stallings-municipal-park",
      "poi_latitude": "35.087159",
      "poi_longitude": "-80.692801",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-821-0322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7ERWU8kVIgRfE7M_CBLhUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c5c8e113bc4159b4dc8dd00d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Blair Mill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1025 Fair Oaks Dr, Stallings, NC 28104, USA",
      "poi_short_description": "Wooded park featuring an 18-hole disc golf course as well as walking trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-3482-76ed-8a8f-e07b3d6005ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-3482-76ed-8a8f-e07b3d6005ba",
        "storage_key": "property/4810300029140992/019f14ef-3482-76ed-8a8f-e07b3d6005ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stallingsnc.org/Our-Community/Things-To-Do/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6370917961934414655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blair-mill-park",
      "poi_latitude": "35.1130151",
      "poi_longitude": "-80.65140180000002",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-821-8557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrX4ab6EkVIgRP6NBviEMalg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4d67ddbb7ea1a5d8e85fce72",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Mint Hill Veterans Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8850 Fairview Rd, Mint Hill, NC 28227, USA",
      "poi_short_description": "Well-used, dog-friendly park, featuring soccer fields, tennis courts, playgrounds and picnic tables, plus a disc golf course.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-38b7-77ed-a2ac-5236cb2b6d58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-38b7-77ed-a2ac-5236cb2b6d58",
        "storage_key": "property/4810300029140992/019f14ef-38b7-77ed-a2ac-5236cb2b6d58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.minthill.com/residents/parks___recreation/mint_hill_veterans_memorial_park.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=15669427343872236765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mint-hill-veterans-memorial-park",
      "poi_latitude": "35.1789665",
      "poi_longitude": "-80.633667",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-545-9726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbFTwsoiVIgR3RxMKSb9dNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2f2a5f19f643fa0bbb0a1366",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Crooked Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Crooked Creek Park, 5900 Oakwood Ln, Indian Trail, NC 28079, USA",
      "poi_short_description": "Kid-friendly park that features baseball fields, playgrounds and a splash pad.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-704e-7108-985b-c5aca45dcbc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-704e-7108-985b-c5aca45dcbc3",
        "storage_key": "property/4810300029140992/019f14e9-704e-7108-985b-c5aca45dcbc3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://itsparksandrec.com/551/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=7228265605590083627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crooked-creek-park",
      "poi_latitude": "35.0651466",
      "poi_longitude": "-80.61695689999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-821-8114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCwkPoXY7VIgRK-hec0X1T2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_044f54a8bf4563949bccf909",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Indian Trail Parks & Recreation",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "315 Matthews-Indian Trail Rd, Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://itsparksandrec.com/551/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=6307959264850024776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-trail-parks--recreation",
      "poi_latitude": "35.0802337",
      "poi_longitude": "-80.6689821",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-821-8114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86f8-758c-b06d-b92496b29522",
        "storage_key": "property/4810300029140992/019f14e9-86f8-758c-b06d-b92496b29522.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-OLKcclVIgRSBkFx4dfilc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_b7701f90b038d4c34f2d957a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Union Towne Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Indian Trail, NC 28079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13645596376312615394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-towne-center",
      "poi_latitude": "35.06742",
      "poi_longitude": "-80.639319",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-5225-760d-9896-2f3c4048b76a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-5225-760d-9896-2f3c4048b76a",
        "storage_key": "property/4810300029140992/019f14ef-5225-760d-9896-2f3c4048b76a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJzdbWSCklVIgR4pF4VpvlXr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_4372eaf80d38e3c77b1a557f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Matthews Independence Pointe",
      "poi_type": "Transportation & Transit",
      "poi_address": "9614 Independence Pointe Pkwy, Matthews, NC 28105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9982605052822371058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matthews-independence-pointe",
      "poi_latitude": "35.1346166",
      "poi_longitude": "-80.7151403",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51ef-72ee-8aaf-d4c738f0f496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51ef-72ee-8aaf-d4c738f0f496",
        "storage_key": "property/4810300029140992/019f14ef-51ef-72ee-8aaf-d4c738f0f496.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJV3q0YeMjVIgR8jp_ymdWiYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_254131b16028f435d9790b61",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Matthews Presbyterian Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "207 W John St, Matthews, NC 28105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-3b21-736b-add0-76e5733d32f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-3b21-736b-add0-76e5733d32f5",
        "storage_key": "property/4810300029140992/019f14ef-3b21-736b-add0-76e5733d32f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.matthewspresbyterian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10958896789034832651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matthews-presbyterian-church",
      "poi_latitude": "35.1164439",
      "poi_longitude": "-80.7247531",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-847-4094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-5226-766e-9735-45e0d7295c18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-5226-766e-9735-45e0d7295c18",
        "storage_key": "property/4810300029140992/019f14ef-5226-766e-9735-45e0d7295c18.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJze3oeKkmVIgRCxOXIJHSFZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "ec_da922fb378b48b94f28e2a5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Northlake Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11574504833305702147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall-park--ride",
      "poi_latitude": "35.352833",
      "poi_longitude": "-80.85521899999999",
      "poi_miles_from_property": "27.8 mi",
      "poi_walking_minutes": "10 hours 25 mins",
      "poi_biking_minutes": "2 hours 35 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfdxJlWmVogRA286UNLmoKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_f19f48dd388b5ed96d61cfa5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Mallard Creek Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1712 J N Pease Pl, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-3e92-7350-9481-5b17dfee04fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-3e92-7350-9481-5b17dfee04fe",
        "storage_key": "property/4810300029140992/019f14ef-3e92-7350-9481-5b17dfee04fe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://ridetransit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10010105514067468082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-park--ride",
      "poi_latitude": "35.32384589999999",
      "poi_longitude": "-80.7730344",
      "poi_miles_from_property": "23.9 mi",
      "poi_walking_minutes": "8 hours 53 mins",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 704-336-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-51ef-72ee-8aaf-d4c738f0f496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ef-51ef-72ee-8aaf-d4c738f0f496",
        "storage_key": "property/4810300029140992/019f14ef-51ef-72ee-8aaf-d4c738f0f496.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaaURbYdVIgRMp8r4u0J64o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c9ca853532d785684de04418",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Trade St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4144275419840309105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2246882",
      "poi_longitude": "-80.8406333",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 45 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN63efwChVogRcef2eolsgzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_7887ec1d890a6ce1205f893d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Amtrak Charlotte Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1914 N Tryon St, Charlotte, NC 28206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-3ca4-7618-ad9c-79022416eb38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-3ca4-7618-ad9c-79022416eb38",
        "storage_key": "property/4810300029140992/019f14ef-3ca4-7618-ad9c-79022416eb38.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amtrak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17371830586323027624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak-charlotte-station",
      "poi_latitude": "35.2412903",
      "poi_longitude": "-80.8226901",
      "poi_miles_from_property": "19.3 mi",
      "poi_walking_minutes": "7 hours 14 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 866-227-0296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZ3bklOhVogRqMYM3OAjFfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_a66a30489f9f762de719ea1b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Rosa Parks Place Community Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2811 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-3c34-753f-82f6-ce73165bd25d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-3c34-753f-82f6-ce73165bd25d",
        "storage_key": "property/4810300029140992/019f14ef-3c34-753f-82f6-ce73165bd25d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16046903153462942466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosa-parks-place-community-transit-center",
      "poi_latitude": "35.2734936",
      "poi_longitude": "-80.8546429",
      "poi_miles_from_property": "21.8 mi",
      "poi_walking_minutes": "8 hours 11 mins",
      "poi_biking_minutes": "2 hours 7 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 704-336-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx3N-wFmhVogRAhtB32UNst4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_2e92214c566b024beb7e623d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Central Ave @ Eastland Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16215879138607143591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-ave--eastland-mall",
      "poi_latitude": "35.206955",
      "poi_longitude": "-80.75269",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 22 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-Ntj9khVIgRp5pYQSlgCuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_73fd4444ae3261d6df25022d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-428f-741c-a1b8-0e7ee9834f50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-428f-741c-a1b8-0e7ee9834f50",
        "storage_key": "property/4810300029140992/019f14ef-428f-741c-a1b8-0e7ee9834f50.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "25.5 mi",
      "poi_walking_minutes": "9 hours 24 mins",
      "poi_biking_minutes": "2 hours 25 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86dd-7468-9917-59acc71709f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86dd-7468-9917-59acc71709f4",
        "storage_key": "property/4810300029140992/019f14e9-86dd-7468-9917-59acc71709f4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_4f8ae17750b8381218aeb08a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Atrium Health Union",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 Hospital Dr, Monroe, NC 28112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-2ab8-726e-a65f-5ba1350b9502.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-2ab8-726e-a65f-5ba1350b9502",
        "storage_key": "property/4810300029140992/019f14ef-2ab8-726e-a65f-5ba1350b9502.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-union?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=14699194454889092193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-union",
      "poi_latitude": "34.9756436",
      "poi_longitude": "-80.5225735",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 980-993-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8690-763d-a426-03d132c83d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8690-763d-a426-03d132c83d66",
        "storage_key": "property/4810300029140992/019f14e9-8690-763d-a426-03d132c83d66.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW55Qz982VIgRYVQOIHoH_ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_57e35a90283d6110cce5afbb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Atrium Health Union West",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Healing Wy, Matthews, NC 28104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-6a29-73c0-a354-821010f5b128.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-6a29-73c0-a354-821010f5b128",
        "storage_key": "property/4810300029140992/019f14e9-6a29-73c0-a354-821010f5b128.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-union-west?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=3499755847197471967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-union-west",
      "poi_latitude": "35.0944953",
      "poi_longitude": "-80.67620590000001",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-993-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8690-763d-a426-03d132c83d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8690-763d-a426-03d132c83d66",
        "storage_key": "property/4810300029140992/019f14e9-8690-763d-a426-03d132c83d66.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ872mv8AlVIgR3zTNiGahkTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_3de42f35d60915f3ad8f4535",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Union County Government, Monroe, NC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 N Main St, Monroe, NC 28112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-4533-723f-ba04-2d34f7b481c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-4533-723f-ba04-2d34f7b481c0",
        "storage_key": "property/4810300029140992/019f14ef-4533-723f-ba04-2d34f7b481c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.unioncountync.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2954496835408557227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-county-government-monroe-nc",
      "poi_latitude": "34.9841603",
      "poi_longitude": "-80.5507028",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-283-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-89fc-7085-9d85-e1eb18f2e4ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-89fc-7085-9d85-e1eb18f2e4ba",
        "storage_key": "property/4810300029140992/019f14e9-89fc-7085-9d85-e1eb18f2e4ba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCV0eSdEwVIgRq_SK3Dd7ACk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_3d08b820adeab4eb69be0c18",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Ucps Central Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 N Church St, Monroe, NC 28112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ucps.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5184604951344625065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ucps-central-office",
      "poi_latitude": "34.9837195",
      "poi_longitude": "-80.5476023",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-289-9170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86e5-706e-8a4f-33d6411f5e74",
        "storage_key": "property/4810300029140992/019f14e9-86e5-706e-8a4f-33d6411f5e74.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIe5-j9MwVIgRqbWg6btq80c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_e6e4fb4c31e0fc9bd4edf503",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Novant Health Mint Hill Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8201 Healthcare Lp, Charlotte, NC 28215, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-41ef-7258-b1ab-8cc7cc9220dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-41ef-7258-b1ab-8cc7cc9220dd",
        "storage_key": "property/4810300029140992/019f14ef-41ef-7258-b1ab-8cc7cc9220dd.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/mint-hill-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-10",
      "poi_directions_map_url": "https://maps.google.com/?cid=81610225204768014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-mint-hill-medical-center",
      "poi_latitude": "35.223025",
      "poi_longitude": "-80.6483794",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 9 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 980-302-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-8690-763d-a426-03d132c83d66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-8690-763d-a426-03d132c83d66",
        "storage_key": "property/4810300029140992/019f14e9-8690-763d-a426-03d132c83d66.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXJs8SYZVIgRDq1eQxHwIQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_dfa96bdd8c08ca9772cb7dea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Pilgrim's Pride Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5901 W Marshville Blvd, Marshville, NC 28103, USA",
      "poi_short_description": "Facility providing logistics services for Pilgrim's Pride Corporation.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-4219-77cd-9be7-511e67a1f225.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-4219-77cd-9be7-511e67a1f225",
        "storage_key": "property/4810300029140992/019f14ef-4219-77cd-9be7-511e67a1f225.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5809816468440423067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilgrims-pride-corporation",
      "poi_latitude": "34.9853917",
      "poi_longitude": "-80.3912764",
      "poi_miles_from_property": "17.8 mi",
      "poi_walking_minutes": "6 hours 32 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 704-624-2171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxdAYX8BIVIgRmxqb20udoFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_6f05ce290cd0570dce51af17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "ATI Specialty Materials",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2020 Ashcraft Ave, Monroe, NC 28110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-453c-76ae-a700-025d7475377e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-453c-76ae-a700-025d7475377e",
        "storage_key": "property/4810300029140992/019f14ef-453c-76ae-a700-025d7475377e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://atimetals.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10774217340409909978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ati-specialty-materials",
      "poi_latitude": "34.9849884",
      "poi_longitude": "-80.5177452",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-289-4511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2EQxxk3VIgR2pL8O5a1hZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "ec_6c81be76020349cb2ff8353b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Greiner Bio-One North America",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4238 Capital Dr, Monroe, NC 28110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-4279-747a-aedb-4d6562fa3211.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-4279-747a-aedb-4d6562fa3211",
        "storage_key": "property/4810300029140992/019f14ef-4279-747a-aedb-4d6562fa3211.webp",
        "width": 576,
        "height": 384
      },
      "poi_business_url": "https://www.gbo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14788626331115486325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greiner-bio-one-north-america",
      "poi_latitude": "35.0215256",
      "poi_longitude": "-80.63286500000001",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-286-3883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr1xu9f0vVIgRdXwgbkvBO80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_5051c66dedbfbb03e1c48c9f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "3M Scott Safety",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4320 Goldmine Rd, Monroe, NC 28110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-47f8-7538-8b6e-0537759c3350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-47f8-7538-8b6e-0537759c3350",
        "storage_key": "property/4810300029140992/019f14ef-47f8-7538-8b6e-0537759c3350.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6492126076796798926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3m-scott-safety",
      "poi_latitude": "35.0154826",
      "poi_longitude": "-80.640647",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-291-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxx-41gvVIgRzgeGJEWqGFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_64d18b6f19f72f3bfb59157f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "generator",
      "poi_name": "Coca-Cola Bottling Co Cons",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4268 Capital Dr, Monroe, NC 28110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14ef-4679-75d6-a623-80abdb07b751.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-4679-75d6-a623-80abdb07b751",
        "storage_key": "property/4810300029140992/019f14ef-4679-75d6-a623-80abdb07b751.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2021869575047929266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coca-cola-bottling-co-cons",
      "poi_latitude": "35.0203771",
      "poi_longitude": "-80.6354655",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-225-1973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-86fe-73bb-9e9d-45ef3ebc34bc",
        "storage_key": "property/4810300029140992/019f14e9-86fe-73bb-9e9d-45ef3ebc34bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4hTUQIwVIgRst3miqofDxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    }
  ],
  "office_hours": [
    {
      "id": "custom_77354bcc-4ff9-48ff-b7ad-44eb9a0faa6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c8d34044-e33f-4dcb-aeef-6c5adc11c650",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fef7c70a-1a28-4cb2-8b6c-477084c311fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_01cc37b9-4d29-4506-b144-bce63d939740",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4075b51d-9d5a-40f9-8020-03538c495ec9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9151fdd3-8e7a-43c7-b644-bbc20f537aca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f911c55cadc3882580b24963",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "rating": "5",
      "name": "Brenda Evans",
      "text": "I have lived in the Kendall Apartments for 2 years and very satisfied. They are close to shopping, medical and recreation . The Kendall has a pool, children's playground and dog park. All the staff is very friendly and there to help you. Any problems and they are there to solve immediately.  You will enjoy living here!\nBrenda  Evans",
      "date": "2025-12-18",
      "title": "false"
    },
    {
      "id": "ec_066cac6b87ab9d19ca1a952e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "rating": "5",
      "name": "Moe",
      "text": "Been living at The Kendall for about a month and everyone: Mary, Jay and Jonas just to name a few , have been wonderful from the beginning of my moving process up until now. They respond time is amazing.",
      "date": "2026-03-24",
      "title": "false"
    },
    {
      "id": "ec_5ba2ac54127f21beeb2b9b60",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "rating": "5",
      "name": "Niqua",
      "text": "A little over a week in and so far so great .\n\nAnd by surprise I got a brand new TV with my move in package 🥳",
      "date": "2026-03-21",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_964d230c-1a87-40a4-ae49-162a3ab8317f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019d02ee-aed8-718b-9230-e4b636b21cdd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a sectional sofa, armchair, coffee table, and TV.",
        "public_id": "019d02ee-aed8-718b-9230-e4b636b21cdd",
        "storage_key": "property/4810300029140992/019d02ee-aed8-718b-9230-e4b636b21cdd.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR,2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cyBm4iQWjWa"
    },
    {
      "id": "custom_b9b021f6-8030-4c3a-9111-db399c57fac2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019d02ee-aea9-754e-8a80-df79e0fb982f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, and weight machines.",
        "public_id": "019d02ee-aea9-754e-8a80-df79e0fb982f",
        "storage_key": "property/4810300029140992/019d02ee-aea9-754e-8a80-df79e0fb982f.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UjX8gRce9Zm"
    },
    {
      "id": "custom_2663ebde-91b8-4640-ab8a-97804a2e471d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f14c2-b6ba-7648-a4c7-51eb0df23e0b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-b6ba-7648-a4c7-51eb0df23e0b",
        "storage_key": "property/4810300029140992/019f14c2-b6ba-7648-a4c7-51eb0df23e0b.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Kendall Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/iOlkZU6ILX8?rel=0"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-61a7-71f8-a52a-04876f60a53f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-kendall",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992"
    },
    {
      "lead_collector_id": "0198aa46-6209-7399-98bd-e8cc81c32ee2",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-kendall",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992"
    },
    {
      "lead_collector_id": "0198aa46-626b-721a-9335-b98ac840d3dd",
      "lead_source": "LANDING_PAGE",
      "name": "the-kendall",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-apartments-with-pools-indian-trail-nc-603",
      "search_query": "apartments with pools Indian Trail NC",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Indian Trail, NC",
      "h2_subtitle": "Discover premium apartments with pools in Indian Trail, NC. Experience exquisite living with modern amenities at The Kendall.",
      "page_copy": "Dive into luxury at The Kendall, where our sparkling pool awaits you in the heart of Indian Trail, NC. Designed for those who appreciate the finer things, our community combines modern living with top-notch amenities. Choose from spacious one, two, or three-bedroom options, each equipped with smart locks and in-unit washers and dryers. Our vibrant atmosphere is complemented further by a state-of-the-art business center and a welcoming dog park, offering unparalleled comfort and convenience.\n\nWhether you're enjoying a swim or relaxing poolside, our amenities are crafted to elevate your lifestyle. Located in Union County, The Kendall is more than just an apartment complex; it's a community where style meets substance. Enjoy all the benefits of a prime location while indulging in the luxurious features that our residents love. Don't just find a home—find your sanctuary with us.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | Apartments with Pools Indian Trail NC",
      "seo_description": "Explore The Kendall's apartments with pools in Indian Trail, NC. Enjoy modern living and luxury amenities tailored to your lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-dog-friendly-apartments-union-county-978",
      "search_query": "dog-friendly apartments Union County",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Union County",
      "h2_subtitle": "Find dog-friendly apartments in Union County at The Kendall. Experience delightful living with amenities designed for pet lovers.",
      "page_copy": "At The Kendall, we understand that pets are family. That's why our dog-friendly apartments in Union County offer a welcoming environment for both you and your furry companion. Our spacious floor plans in one, two, or three-bedroom layouts provide ample space for your pets to roam. With smart locks and in-unit washers and dryers, you'll enjoy modern conveniences designed for hassle-free living.\n\nOur onsite dog park is the perfect spot for your pup to play and make friends while you unwind in our vibrant community. Beyond our pet-friendly offerings, The Kendall boasts a wet bar, business center, and a sparkling pool—creating an all-inclusive living experience right in the heart of Indian Trail, NC. Join a community that celebrates pet ownership and offers the amenities you've been looking for.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | Dog-Friendly Apartments Union County",
      "seo_description": "Welcome to The Kendall, offering dog-friendly apartments in Union County. Enjoy amenities tailored for pet owners in Indian Trail, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-apartments-with-in-unit-washer-dryer-28079-158",
      "search_query": "apartments with in-unit washer dryer 28079",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer in 28079",
      "h2_subtitle": "Experience the convenience of apartments with in-unit washer dryer in the 28079 area. Enjoy modern amenities at The Kendall.",
      "page_copy": "Discover unparalleled convenience at The Kendall, where all our apartments feature in-unit washer and dryer in the 28079 area. This sought-after amenity allows you to enjoy hassle-free laundry days right within the comfort of your own home. Our spacious one, two, and three-bedroom floor plans are designed with modern living in mind, offering smart locks and generous layouts to cater to your lifestyle.\n\nNestled in the vibrant community of Indian Trail, NC, The Kendall offers more than just top-notch in-unit amenities. Dive into relaxation at our sparkling pool or get productive at our state-of-the-art business center. With pet-friendly facilities, including a dedicated dog park, your four-legged friend will love living here too. Elevate your everyday life and experience comfort and style at The Kendall.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | Apartments with In-Unit Washer Dryer 28079",
      "seo_description": "Find apartments with in-unit washer dryer at The Kendall in 28079. Enjoy modern living with premium amenities in Indian Trail, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-luxury-apartments-with-fitness-center-indian-trail-518",
      "search_query": "luxury apartments with fitness center Indian Trail",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center in Indian Trail",
      "h2_subtitle": "Discover luxury apartments with a fitness center in Indian Trail. Experience upscale living at The Kendall with premium amenities.",
      "page_copy": "Welcome to The Kendall, where luxury meets lifestyle in Indian Trail. Our luxury apartments featuring a fitness center are designed for those who appreciate top-quality amenities. Choose from our elegant one, two, or three-bedroom layouts, each crafted with modern conveniences like smart locks and in-unit washers and dryers. Our fitness center caters to all your health goals, providing a state-of-the-art environment to invigorate your daily routine.\n\nThe Kendall is more than just a home; it's a community where luxury living comes with extra perks. Unwind after a workout in our sparkling pool or socialize with neighbors at our wet bar. The prime location in Indian Trail offers easy access to local attractions while ensuring a private, serene living space. Find your perfect balance of comfort and sophistication at The Kendall, where upscale amenities await you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "<p class=\"rteBlock\">The Kendall | Apartments with Fitness Center Indian Trail</p>",
      "seo_description": "Indulge in luxury apartments with a fitness center at The Kendall, Indian Trail. Enjoy premium amenities for upscale living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-smart-lock-apartments-union-county-21",
      "search_query": "smart lock apartments in Union County",
      "category": "Amenity",
      "h1_title": "Smart Lock Apartments in Union County",
      "h2_subtitle": "Discover modern living with smart lock apartments in Union County. The Kendall offers security and convenience.",
      "page_copy": "At The Kendall, we prioritize your security and convenience with our smart lock apartments in Union County. Each unit is equipped with state-of-the-art smart locks, allowing you to experience modern living with enhanced security. Our one, two, and three-bedroom layouts are designed to provide a seamless blend of comfort and technology, ensuring you enjoy a hassle-free lifestyle.\n\nLocated in the heart of Indian Trail, NC, The Kendall offers more than just high-tech security. Our community boasts a range of premium amenities including a business center, sparkling pool, and pet-friendly facilities like a dog park. With the integration of smart home technology, we make everyday tasks simpler and more efficient. Join our community and embrace a new standard of living at The Kendall.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | Smart Lock Apartments in Union County",
      "seo_description": "Experience secure, modern living with smart lock apartments in Union County at The Kendall, Indian Trail. Enjoy convenience with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-one-bedroom-apartments-indian-trail-nc-481",
      "search_query": "one bedroom apartments indian trail nc",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Indian Trail, NC",
      "h2_subtitle": "Explore our spacious one-bedroom apartments in Indian Trail, NC. The Kendall offers modern living with luxurious amenities.",
      "page_copy": "Discover the perfect blend of style and functionality with our one-bedroom apartments in Indian Trail, NC, at The Kendall. Designed with modern living in mind, each unit offers spacious interiors, smart locks, and in-unit washers and dryers. These thoughtfully crafted homes are perfect for singles or couples looking for a cozy yet sophisticated living space.\n\nThe Kendall isn't just about the interiors; our community promises an exceptional living experience with top-tier amenities. Unwind after a long day in our sparkling pool, or enjoy a drink with friends at our wet bar. With a dedicated dog park, even your pets will love living here. Whether you’re working from home in our business center or enjoying the local atmosphere of Indian Trail, The Kendall is the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | One Bedroom Apartments Indian Trail, NC",
      "seo_description": "Explore modern one-bedroom apartments in Indian Trail, NC, at The Kendall. Enjoy luxury amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-two-bedroom-floor-plans-union-county-800",
      "search_query": "two bedroom floor plans union county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans in Union County",
      "h2_subtitle": "Discover two-bedroom floor plans in Union County at The Kendall. Experience ample space and modern design in Union County's best location.",
      "page_copy": "Explore the spacious two-bedroom floor plans available at The Kendall, nestled in the heart of Union County. These beautifully crafted apartments offer the perfect blend of style and practicality, designed to cater to your lifestyle needs. Each unit features modern conveniences, including smart locks and in-unit washers and dryers, ensuring a seamless living experience.\n\nLiving at The Kendall means enjoying not only a spacious home but also access to a host of luxurious amenities. Whether you want to relax by the sparkling pool or entertain guests at the wet bar, our community offers it all. With a business center and pet-friendly spaces, including a dog park, The Kendall promises a vibrant and fulfilling lifestyle. Experience contemporary living in Union County’s premier apartment community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | Two Bedroom Floor Plans Union County",
      "seo_description": "Experience spacious and modern two-bedroom floor plans in Union County at The Kendall. Enjoy luxurious amenities and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-three-bedroom-rentals-near-28079-267",
      "search_query": "three bedroom rentals near 28079",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Rentals Near 28079",
      "h2_subtitle": "Find expansive three-bedroom rentals near 28079 at The Kendall. Experience modern living with top-notch amenities.",
      "page_copy": "Discover the perfect family home with our three-bedroom rentals near 28079, located at The Kendall in Indian Trail, NC. These units offer abundant space and modern features like smart locks and in-unit washers and dryers, ensuring a comfortable living environment tailored for families or roommates seeking extra space.\n\nThe Kendall provides more than just roomy interiors. Our community comes complete with a range of exceptional amenities to enhance your living experience. Dive into our sparkling pool, handle business at our well-equipped business center, or take a stroll with your pet in our dedicated dog park. Situated in a convenient location near schools, shopping, and dining, The Kendall offers the perfect blend of comfort and convenience in the 28079 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | Three Bedroom Rentals Near 28079",
      "seo_description": "Explore spacious three-bedroom rentals near 28079 at The Kendall in Indian Trail, NC. Enjoy modern amenities and a vibrant community environment.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-apartments-near-porter-ridge-elementary-221",
      "search_query": "apartments near Porter Ridge Elementary School Indian Trail NC",
      "category": "School",
      "h1_title": "Apartments Near Porter Ridge Elementary School, Indian Trail, NC",
      "h2_subtitle": "Discover the convenience of living near Porter Ridge Elementary School in Indian Trail, NC. The Kendall offers family-friendly apartment amenities and spacious layouts.",
      "page_copy": "Living close to education has never been easier with The Kendall's prime location near Porter Ridge Elementary School in Indian Trail, NC. Our apartments offer families a perfect mix of comfort, style, and proximity to excellent educational facilities. Our one, two, and three-bedroom floor plans provide ample space, smart features such as smart locks, and practical amenities like in-unit washers and dryers.\n\nThe community at The Kendall is designed with families in mind, offering amenities that cater to all. Spend a weekend afternoon lounging by the sparkling pool, or have a family picnic in our beautifully landscaped areas. With on-site amenities such as a business center and a dog park, convenience and enjoyment are always a step away. Embrace the advantages of living near Porter Ridge Elementary at The Kendall.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | Apartments Near Porter Ridge Elementary",
      "seo_description": "Find family-friendly apartments near Porter Ridge Elementary School at The Kendall in Indian Trail, NC. Enjoy modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "4810300029140992",
      "source": "custom",
      "page_item_url": "the-kendall-apartments-near-porter-ridge-high-union-county-138",
      "search_query": "apartments near Porter Ridge High School Union County",
      "category": "School",
      "h1_title": "Apartments Near Porter Ridge High School, Union County",
      "h2_subtitle": "Explore comfortable living near Porter Ridge High School in Union County. Discover all The Kendall has to offer right in Indian Trail, NC.",
      "page_copy": "For those seeking an ideal location near Porter Ridge High School in Union County, The Kendall offers a perfect housing solution. Our modern apartments provide easy access to education and community amenities, making it the perfect choice for families and students alike. With beautifully designed one, two, and three-bedroom options, each apartment is equipped with smart locks and includes washers and dryers for ultimate convenience.\n\nLife at The Kendall is as enriching as it is convenient. Residents can enjoy a refreshing dip in the sparkling pool, host gatherings at the wet bar, or focus on work in the business center. The family-friendly environment is enhanced by amenities like a dog park, fostering a welcoming community. Located just a short drive from Porter Ridge High School, The Kendall ensures a seamless blend of academic and upscale living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f6c12-e561-744c-a80d-f53c9db34e80",
        "storage_key": "property/4810300029140992/019f6c12-e561-744c-a80d-f53c9db34e80.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Kendall | Apartments Near Porter Ridge High Union County",
      "seo_description": "Experience modern living near Porter Ridge High School in Union County at The Kendall. Enjoy upscale amenities and spacious apartment layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5478"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "3391702183"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a5c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a5c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5056164"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MB495Z3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "9835707285"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "deb7a6d2f911f162"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/er5v53rrpny"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/b2ec7364-71db-4f94-a437-810981fe40a7"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "980-409-2163"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkppQ1E4VEozNDZyZGhrSk5Wak5zUnc9PSIsInZhbHVlIjoidUdYQVd1SGFyU0xyVlZ4V2hENnhBdz09IiwibWFjIjoiY2FjYTQzODIzY2UzMDViNzE2YmI5OTBiY2I2ZDk0MDcyZDg0YzNmYjM0ZDJkODRlYzNlODY0MWY0ODcxNmRkZSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5478",
  "custom_repli_id": "3391702183",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a5c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a5c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5056164",
  "custom_google_gtm_id": "GTM-MB495Z3",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "9835707285",
  "custom_knock_community_id": "deb7a6d2f911f162",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/er5v53rrpny",
  "custom_self_guided_tour_url": "https://selftournow.com/property/b2ec7364-71db-4f94-a437-810981fe40a7",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "980-409-2163",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkppQ1E4VEozNDZyZGhrSk5Wak5zUnc9PSIsInZhbHVlIjoidUdYQVd1SGFyU0xyVlZ4V2hENnhBdz09IiwibWFjIjoiY2FjYTQzODIzY2UzMDViNzE2YmI5OTBiY2I2ZDk0MDcyZDg0YzNmYjM0ZDJkODRlYzNlODY0MWY0ODcxNmRkZSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "bd82875f-eba2-467f-aca1-d2bb2aadc5f7",
  "custom_audioeye_site_hash": "6bdb5a47e668d23ec81ad1dfd6541b04"
};

export const generatedAt = '2026-11-03T20:28:38.906Z';
